'use strict';

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var schema = {
  '$schema': 'http://json-schema.org/draft-07/schema#',
  'type': 'object',
  'properties': {
    'booleanIcon': {
      'type': 'string'
    },
    'bordered': {
      'type': 'boolean'
    },
    'columnSearch': {
      'type': 'boolean'
    },
    'dark': {
      'type': 'boolean'
    },
    'dateFormat': {
      'type': 'string'
    },
    'dateTimeFormat': {
      'type': 'string'
    },
    'debounceTime': {
      'type': 'integer'
    },
    'debug': {
      'type': 'boolean'
    },
    'displayedEntries': {
      'type': 'boolean'
    },
    'emptyTemplate': {
      'type': 'string'
    },
    'fixedHeight': {
      'type': 'boolean'
    },
    'footClassName': {
      'type': 'string'
    },
    'footers': {
      'type': 'boolean'
    },
    'fullTextSearch': {
      'type': 'boolean'
    },
    'headClassName': {
      'type': 'string'
    },
    'headers': {
      'type': 'boolean'
    },
    'hover': {
      'type': 'boolean'
    },
    'layout': {
      'type': 'string'
    },
    'loadingTemplate': {
      'type': 'string'
    },
    'locale': {
      'type': 'string'
    },
    'pageIndex': {
      'type': 'integer',
      'minimum': 0
    },
    'pageSize': {
      'type': 'integer',
      'minimum': 0,
      'maximum': 500
    },
    'rowStatusKey': {
      'type': 'string'
    },
    'schema': {
      'type': 'object'
    },
    'searchPlaceholder': {
      'type': 'string'
    },
    'small': {
      'type': 'boolean'
    },
    'sortHeader': {
      'type': 'string'
    },
    'sortDirection': {
      'type': 'string',
      'pattern': '^(asc|desc)$'
    },
    'striped': {
      'type': 'boolean'
    },
    'totalCount': {
      'type': 'integer',
      'minimum': 0
    },
    'ttl': {
      'type': 'integer',
      'minimum': -1
    },
    'visiblePageCount': {
      'type': 'integer',
      'minimum': 4
    },
    'width': {
      'type': 'string'
    }
  },
  'required': ['schema']
};

var r = function r(_r, t) {
  return !(null != _r.minimum && null == _r.maximum && t < _r.minimum) && !(null != _r.maximum && null == _r.minimum && t > _r.maximum) && (null == _r.minimum || null == _r.maximum || _r.minimum !== _r.maximum || _r.minimum === t);
},
    t = {
  integer: function integer(t, i) {
    return "number" == typeof i && Math.floor(i) === i && !!r(t, i);
  },
  number: function number(t, i) {
    return "number" == typeof i && !!r(t, i);
  },
  string: function string(r, t) {
    return "string" == typeof t;
  },
  "boolean": function boolean(r, t) {
    return "boolean" == typeof t;
  },
  array: function array(r, t) {
    return "object" == _typeof(t) && Array.isArray(t);
  },
  object: function object(r, t) {
    return "object" == _typeof(t) && t && !Array.isArray(t);
  }
},
    i = function i(r, t, _i) {
  var e = function e(r, t) {
    if (r["enum"] && Array.isArray(r["enum"]) && r["enum"].length > 0 && !r["enum"].find(function (r) {
      return r === t;
    })) return 1 === r["enum"].length ? "must equal " + r["enum"][0] : 2 === r["enum"].length ? "must equal " + r["enum"].join(" or ") : "must be one of " + r["enum"].join(", ");
  },
      n = function n(r, t) {
    return null != r.minimum && null != r.maximum && (t < r.minimum || t > r.maximum) ? "must be between " + r.minimum + " and " + r.maximum : null != r.minimum && null == r.maximum && t < r.minimum ? "must be greater than or equal to " + r.minimum : null != r.maximum && null == r.minimum && t > r.maximum ? "must be less than or equal to " + r.maximum : e(r, t);
  },
      u = {
    integer: n,
    number: n,
    string: e,
    "enum": e
  },
      m = null;

  return r.type && (m = r.type), r["enum"] && (m = "enum"), u[m] && (0, u[m])(r, t) || _i;
},
    e = {
  "date-time": /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-[0-9]{2}[tT ]\d{2}:\d{2}:\d{2}(\.\d+)?([zZ]|[+-]\d{2}:\d{2})$/,
  date: /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-[0-9]{2}$/,
  time: /^\d{2}:\d{2}:\d{2}$/,
  email: /^\S+@\S+$/,
  uri: /^[a-zA-Z][a-zA-Z0-9+-.]*:[^\s]*$/
},
    n = function n(r) {
  this.schema = r, this.data = null, this.errors = {};
};

n.prototype.validate = function (r) {
  return this.data = r, this.errors = {}, this._visit(this.schema.properties, this.schema.required, r), {
    isValid: 0 === Object.keys(this.errors).length,
    errors: this.errors,
    data: this.data
  };
}, n.prototype._isValid = function (r, t, e) {
  return void 0 === e || (this._isValidOneOf(t, e) ? this._isValidAllOf(t, e) ? this._isValidAnyOf(t, e) ? this._isValidEnum(t, e) ? this._isValidType(t, e) ? !!this._isValidFormat(t, e) || (this._addError(r, i(t, e, "format must be " + t.format)), !1) : (this._addError(r, i(t, e, "type must be " + t.type)), !1) : (this._addError(r, i(t, e, "type must be " + t["enum"])), !1) : (this._addError(r, i(t, e, "must be any of " + t.anyOf.length + " values")), !1) : (this._addError(r, i(t, e, "must be all of " + t.allOf.length + " values")), !1) : (this._addError(r, i(t, e, "must be one of " + t.oneOf.length + " values")), !1));
}, n.prototype._isValidType = function (r, i) {
  return !r.type || (0, t[r.type])(r, i);
}, n.prototype._isValidOneOf = function (r, t) {
  if (!r.oneOf) return !0;
  if (!Array.isArray(r.oneOf)) return !1;

  for (var i = 0, e = r.oneOf; i < e.length; i += 1) {
    var n = e[i];
    if ("object" === n.type && !this._isValidRequired(n.required, t)) return !1;
    if (n["enum"] && Array.isArray(n["enum"]) && n["enum"].length > 0 && this._isValidEnum(n, t)) return !0;
    if (this._isValidType(n, t) && this._isValidFormat(n, t)) return !0;
  }

  return !1;
}, n.prototype._validCount = function (r, t) {
  for (var i = 0, e = 0, n = r; e < n.length; e += 1) {
    var u = n[e];
    if ("object" === u.type && this._isValidRequired(u.required, t)) return 0;
    this._isValidEnum(u, t) ? ++i : this._isValidType(u, t) && this._isValidFormat(u, t) && ++i;
  }

  return i;
}, n.prototype._isValidAllOf = function (r, t) {
  return !0;
}, n.prototype._isValidAnyOf = function (r, t) {
  return !r.anyOf || !!Array.isArray(r.anyOf) && this._validCount(r.anyOf, t) > 0;
}, n.prototype._isValidFormat = function (r, t) {
  return !r.format || e[r.format].test(t);
}, n.prototype._isValidEnum = function (r, t) {
  return !r["enum"] || Array.isArray(r["enum"]) && !!r["enum"].find(function (r) {
    return r === t;
  });
}, n.prototype._isValidRequired = function (r, t) {
  if (!r) return !0;
  if (!Array.isArray(r)) return !1;

  for (var i = 0, e = r; i < e.length; i += 1) {
    if (null == t[e[i]]) return !1;
  }

  return !0;
}, n.prototype._visit = function (r, t, i) {
  this._isValidRequired(t, i) || this._addError(t.join(", ") + " " + (1 === t.length ? "is" : "are") + " required");

  for (var e = 0, n = Object.keys(r); e < n.length; e += 1) {
    var u = n[e],
        m = r[u];
    this._isValid(u, m, i[u]) && void 0 !== i[u] && "object" === m.type && m.properties && this._visit(m.properties, m.required, i[u]);
  }
}, n.prototype._addError = function (r, t) {
  this.errors[r] = t;
};

function validateOptions(options) {
  var v = new n(schema);
  var res = v.validate(options);
  var dataValid = options.data && typeof options.data === 'function';

  if (!res.isValid || !dataValid) {
    throw new Error('Invalid options supplied!');
  }
}

var letters = 'abcdefghijklmnopqrstuvwxyz';
var numbers = '1234567890';
var charset = letters + letters.toUpperCase() + numbers;

function randomElement(array) {
  return array[Math.floor(Math.random() * array.length)];
}

function generate() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
  var r = '';

  for (var i = 0; i < length; i++) {
    r += randomElement(charset);
  }

  return r;
}
function generateId(prefix) {
  return "".concat(prefix ? prefix + '-' : '').concat(generate());
}

var Store = /*#__PURE__*/function () {
  function Store(options) {
    _classCallCheck(this, Store);

    this.originalOptions = Object.assign({}, options);
    var defaultState = {
      booleanIcon: '#table_checkmark, #table_delete_sign',
      currencySymbol: '',
      bordered: false,
      cache: {},
      cellTemplates: null,
      columnSearch: false,
      columnSearchInputAttributes: null,
      columnSearchDebounced: null,
      columnSearchCaseSensitive: false,
      columnSearchHighlight: false,
      compiledTemplates: {},
      dark: false,
      dateFormat: null,
      dateTimeFormat: null,
      debounceTime: 300,
      debug: false,
      displayedEntries: true,
      displayedEntriesRendered: false,
      emptyTemplate: '<p class="text-center m-0">No records</p>',
      filteredCache: null,
      filteredTotalCount: -1,
      firstVisiblePageIndex: 0,
      firstTotalCount: -1,
      fixedHeight: false,
      focusElement: null,
      footClassName: null,
      footers: false,
      footRendered: false,
      fullTextSearch: false,
      fullTextSearchInputAttributes: null,
      fullTextSearchDebounced: null,
      fullTextSearchHighlight: false,
      fullTextQuery: null,
      headClassName: null,
      headers: true,
      headRendered: false,
      hover: false,
      iconIdPrefix: '',
      id: generateId('table'),
      layout: 'auto',
      loadedData: null,
      loadingTemplate: '<p class="text-center m-0">Loading...</p>',
      locale: 'en-GB',
      pageIndex: 0,
      pageSize: 50,
      paginationRendered: false,
      rowStatusKey: 'rowStatus',
      searchColumns: null,
      searchPlaceholder: 'Search',
      small: false,
      sortHeader: null,
      sortDirection: null,
      striped: false,
      tableRendered: false,
      totalCount: 0,
      ttl: -1,
      visiblePageCount: 4,
      width: '100%'
    };
    this.observers = [];
    this.state = Object.assign({}, defaultState, options);
  }

  _createClass(Store, [{
    key: "registerObserver",
    value: function registerObserver(observer) {
      this.observers.push(observer);
    }
  }, {
    key: "setState",
    value: function setState(state) {
      var notify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var complete = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
      this.state = Object.assign({}, this.state, state);

      if (notify) {
        this._notifyObservers(complete);
      }
    }
  }, {
    key: "getResetState",
    value: function getResetState() {
      return {
        filteredCache: null,
        filteredTotalCount: -1,
        firstVisiblePageIndex: 0,
        fullTextQuery: null,
        pageIndex: 0,
        sortHeader: null,
        sortDirection: null,
        searchColumns: null,
        paginationRendered: false
      };
    }
  }, {
    key: "_notifyObservers",
    value: function _notifyObservers(complete) {
      var _this = this;

      this.observers.forEach(function (o) {
        return o.update(_this);
      });
      setTimeout(complete);
    }
  }]);

  return Store;
}();

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */

var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';
/** Detect free variable `global` from Node.js. */

var freeGlobal = (typeof global === "undefined" ? "undefined" : _typeof(global)) == 'object' && global && global.Object === Object && global;
/** Detect free variable `self`. */

var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = freeGlobal || freeSelf || Function('return this')();
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }

  return array;
}
/** Used for built-in method references. */


var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString = objectProto.toString;
/** Built-in value references. */

var _Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */

function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];

    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }

  return result;
}
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */


function isFlattenable(value) {
  return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */


function flatten(array) {
  var length = array ? array.length : 0;
  return length ? baseFlatten(array, 1) : [];
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */


function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */


var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */

function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */


function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */


function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */


function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */


function isObject(value) {
  var type = _typeof(value);

  return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */


function isObjectLike(value) {
  return !!value && _typeof(value) == 'object';
}

/* global Node */

var h = function h(tag, attrs) {
  var elm = null;
  var isSvg = false;

  if (['svg', 'use', 'symbol', 'path', 'g', 'defs', 'title'].indexOf(tag) > -1) {
    elm = document.createElementNS('http://www.w3.org/2000/svg', tag);
    isSvg = true;
  } else {
    elm = document.createElement(tag);
  }

  for (var key in attrs) {
    if (key.slice(0, 2) === 'on') {
      var evtName = key.slice(2);
      var cb = attrs[key];
      if (cb == null) continue; // we can use null or undefined to suppress

      elm.addEventListener(evtName, cb);
    } else if (['disabled', 'selected', 'checked'].indexOf(key) > -1) {
      if (attrs[key]) {
        elm.setAttribute(key, key);
      }
    } else if (key === 'xlinkHref' && isSvg) {
      if (attrs[key]) {
        elm.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', attrs[key]);
      }
    } else if (key === 'href' && isSvg) {
      if (attrs[key]) {
        elm.setAttributeNS('http://www.w3.org/1999/xlink', 'href', attrs[key]);
      }
    } else {
      if (attrs[key] == null) continue; // Don't set undefined or null attributes

      elm.setAttribute(key, attrs[key]);
    }
  }

  for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  if (children.length === 0) {
    return elm;
  }

  var fc = flatten(children);
  fc.forEach(function (child) {
    if (child instanceof Node) {
      elm.appendChild(child);
    } else {
      elm.appendChild(document.createTextNode(child));
    }
  });

  if (tag == null) {
    return elm.children;
  }

  return elm;
};

function getRowIndex(tableContext, id) {
  var cache = null;

  if (tableContext.store.state.filteredTotalCount > -1) {
    cache = tableContext.store.state.filteredCache;
  } else {
    cache = tableContext.store.state.cache;
  }

  var keys = Object.keys(cache);

  for (var i = 0; i < keys.length; i++) {
    if (cache[keys[i]].id === id) {
      return keys[i];
    }
  }

  return -1;
}

function getOnChecked(tableContext, d, k, onAction, id) {
  if (onAction) {
    return function (e) {
      var index = getRowIndex(tableContext, id);

      var rowData = _objectSpread2({}, d, _defineProperty({}, k, e.target.checked));

      onAction(tableContext.table, k, [{
        index: index,
        rowData: rowData,
        value: e.target.checked
      }]);
    };
  }
}

var Checkbox = function Checkbox(tableContext, data, key, value, id) {
  var editable = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var onAction = tableContext.store.state.onAction;
  var disabled = !editable;
  return h("input", {
    type: "checkbox",
    name: "".concat(id, "_").concat(key),
    value: value,
    checked: value,
    disabled: disabled,
    onclick: getOnChecked(tableContext, data, key, onAction, id)
  });
};

/** @jsx h */
var Mailto = function Mailto(value) {
  return h("a", {
    href: "mailto:".concat(value),
    rel: "noopener"
  }, value);
};

/** @jsx h */
var Hyperlink = function Hyperlink(value) {
  return h("a", {
    href: value
  }, value);
};

function getIcon(prefix, icon, title) {
  var iconOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (icon) {
    var fi = icon;

    if (prefix && prefix !== '' && icon.substring(0, 1) === '#') {
      fi = "#".concat(prefix).concat(icon.substring(1));
    } else if (prefix && prefix !== '') {
      fi = "#".concat(prefix).concat(icon);
    }

    return h("div", {
      "class": "mc-btn__icon"
    }, h("svg", {
      "class": "icon".concat(iconOnly ? ' mr-0' : ''),
      width: "18",
      height: "18"
    }, h("use", {
      xlinkHref: fi,
      href: fi
    })));
  }

  return '';
}

function getText(prop, key, data) {
  if (prop.color === 'link') {
    if (data[key]) {
      return h("div", null, data[key].value != null ? data[key].value : data[key]);
    } else {
      return prop.title ? h("div", null, prop.title) : '';
    }
  }

  return prop.title ? h("div", null, prop.title) : '';
}

function getOnClick(tableContext, d, k, onAction, id) {
  if (onAction) {
    return function () {
      var index = getRowIndex(tableContext, id);
      onAction(tableContext.table, k, [{
        index: index,
        rowData: d,
        value: null
      }]);
    };
  }
}

var Button = function Button(tableContext, prop, data, key, value, id, classes) {
  var onAction = tableContext.store.state.onAction;
  var disabled = false;
  var hidden = false;

  if (value && _typeof(value) === 'object' && value[key]) {
    if (value[key].disabled != null) disabled = value[key].disabled;
    if (value[key].hidden != null) hidden = value[key].hidden;
  }

  if (prop.hidden != null) {
    hidden = prop.hidden;
  }

  return h("div", {
    "class": "mc-btn d-inline-block"
  }, h("button", _defineProperty({
    type: "button",
    disabled: prop.disabled ? prop.disabled : false,
    title: prop.title ? prop.title : '',
    "class": "btn mc-btn__button mc-btn__button--sm btn-sm btn-".concat(prop.color || 'secondary', " mc-btn__button--").concat(prop.color || 'secondary').concat(classes ? " ".concat(classes) : '').concat(hidden ? ' d-none' : ''),
    onclick: getOnClick(tableContext, data, key, onAction, id)
  }, "disabled", disabled), getIcon(tableContext.store.state.iconIdPrefix, prop.icon, prop.title, prop.iconOnly), prop.iconOnly ? '' : getText(prop, key, data)));
};

function getOnChanged(tableContext, d, k, onAction, id, nv) {
  if (onAction) {
    return function (e) {
      var index = getRowIndex(tableContext, id);
      var v = nv.find(function (x) {
        return x.id === e.target.value;
      });
      onAction(tableContext.table, k, [{
        index: index,
        rowData: d,
        value: v.data
      }]);
    };
  }
}

function getOption(v) {
  if (v.data && _typeof(v.data) === 'object' && v.data.value && v.data.text) {
    return h("option", {
      value: v.id,
      selected: v.data.selected
    }, v.data.text);
  } else {
    return h("option", {
      value: v.id
    }, v.data || '');
  }
}

var Select = function Select(tableContext, data, key, value, id) {
  var editable = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var onAction = tableContext.store.state.onAction;
  var disabled = !editable;
  var nv = [{
    id: generateId(),
    data: null
  }].concat(_toConsumableArray(value.map(function (v) {
    return {
      id: generateId(),
      data: v
    };
  })));
  return h("select", {
    name: "".concat(id, "_").concat(key),
    "class": "form-control".concat(tableContext.store.state.small ? ' form-control-sm' : ''),
    disabled: disabled,
    onchange: getOnChanged(tableContext, data, key, onAction, id, nv)
  }, nv.map(function (v) {
    return getOption(v);
  }));
};

/** @jsx h */
var Icon = function Icon(tableContext, val) {
  var prefix = tableContext.store.state.iconIdPrefix;
  var icon = tableContext.store.state.booleanIcon.split(',');
  var fi;
  var className;

  if (val) {
    fi = icon[0];
    className = 'icon fill-success';
  } else {
    fi = icon[1];
    className = 'icon fill-danger';
  }

  if (prefix && prefix !== '' && !/#table_/.test(icon[0]) && icon[0].substring(0, 1) === '#') {
    fi = "#".concat(prefix).concat(icon[0].substring(1));
  } else if (prefix && prefix !== '' && !/#table_/.test(icon[0])) {
    fi = "#".concat(prefix).concat(icon[0]);
  }

  return h("svg", {
    "class": className,
    width: "18",
    height: "18"
  }, h("use", {
    xlinkHref: fi,
    href: fi
  }));
};

var Currency = function Currency(tableContext, val, decimal) {
  var dec = decimal;
  var opts;
  var locale = tableContext.store.state.locale;

  if (!dec && dec !== 0) {
    dec = 2;
  }

  if (dec !== 0) {
    opts = {
      minimumFractionDigits: dec,
      maximumFractionDigits: dec
    };
  }

  var symbol = tableContext.store.state.currencySymbol;
  return "".concat(symbol).concat(Number(val).toLocaleString(locale, opts));
};

function resolveToString(source, context) {
  return source.replace(/\{\{(\w+)\}\}/g, function (_, k) {
    return context[k];
  });
}

function elementFromString(html) {
  var div = document.createElement('div');
  div.innerHTML = html.trim();
  return div.firstChild;
}

function isSchema(key, obj) {
  if (key === 'actions') {
    return false;
  }

  return _typeof(obj) === 'object' && obj.hasOwnProperty('properties');
}
function isStringType(obj) {
  return obj.type === 'string';
}
function isNumberType(obj) {
  return obj.type === 'number';
}
function isBooleanType(obj) {
  return obj.type === 'boolean';
}
function isDateType(obj) {
  return obj.type === 'string' && obj.format && obj.format === 'date';
}
function isDateTimeType(obj) {
  return obj.type === 'string' && obj.format && obj.format === 'date-time';
}
function isEmailType(obj) {
  return obj.type === 'string' && obj.format && obj.format === 'email';
}
function isUriType(obj) {
  return obj.type === 'string' && obj.format && obj.format === 'uri';
}

var SECONDS_A_MINUTE = 60;
var SECONDS_A_HOUR = SECONDS_A_MINUTE * 60;
var SECONDS_A_DAY = SECONDS_A_HOUR * 24;
var SECONDS_A_WEEK = SECONDS_A_DAY * 7;
var MILLISECONDS_A_SECOND = 1e3;
var MILLISECONDS_A_MINUTE = SECONDS_A_MINUTE * MILLISECONDS_A_SECOND;
var MILLISECONDS_A_HOUR = SECONDS_A_HOUR * MILLISECONDS_A_SECOND;
var MILLISECONDS_A_DAY = SECONDS_A_DAY * MILLISECONDS_A_SECOND;
var MILLISECONDS_A_WEEK = SECONDS_A_WEEK * MILLISECONDS_A_SECOND; // English locales

var MS = 'millisecond';
var S = 'second';
var MIN = 'minute';
var H = 'hour';
var D = 'day';
var W = 'week';
var M = 'month';
var Q = 'quarter';
var Y = 'year';
var DATE = 'date';
var FORMAT_DEFAULT = 'YYYY-MM-DDTHH:mm:ssZ';
var INVALID_DATE_STRING = 'Invalid Date'; // regex

var REGEX_PARSE = /^(\d{4})-?(\d{1,2})-?(\d{0,2})[^0-9]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?.?(\d{1,3})?$/;
var REGEX_FORMAT = /\[([^\]]+)]|Y{2,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g;

var padStart = function padStart(string, length, pad) {
  var s = String(string);
  if (!s || s.length >= length) return string;
  return "" + Array(length + 1 - s.length).join(pad) + string;
};

var padZoneStr = function padZoneStr(instance) {
  var negMinuts = -instance.utcOffset();
  var minutes = Math.abs(negMinuts);
  var hourOffset = Math.floor(minutes / 60);
  var minuteOffset = minutes % 60;
  return "" + (negMinuts <= 0 ? '+' : '-') + padStart(hourOffset, 2, '0') + ":" + padStart(minuteOffset, 2, '0');
};

var monthDiff = function monthDiff(a, b) {
  // function from moment.js in order to keep the same result
  var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month());
  var anchor = a.clone().add(wholeMonthDiff, M);
  var c = b - anchor < 0;
  var anchor2 = a.clone().add(wholeMonthDiff + (c ? -1 : 1), M);
  return Number(-(wholeMonthDiff + (b - anchor) / (c ? anchor - anchor2 : anchor2 - anchor)) || 0);
};

var absFloor = function absFloor(n) {
  return n < 0 ? Math.ceil(n) || 0 : Math.floor(n);
};

var prettyUnit = function prettyUnit(u) {
  var special = {
    M: M,
    y: Y,
    w: W,
    d: D,
    D: DATE,
    h: H,
    m: MIN,
    s: S,
    ms: MS,
    Q: Q
  };
  return special[u] || String(u || '').toLowerCase().replace(/s$/, '');
};

var isUndefined = function isUndefined(s) {
  return s === undefined;
};

var U = {
  s: padStart,
  z: padZoneStr,
  m: monthDiff,
  a: absFloor,
  p: prettyUnit,
  u: isUndefined
};

// We don't need weekdaysShort, weekdaysMin, monthsShort in en.js locale
var en = {
  name: 'en',
  weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
  months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_')
};

var L = 'en'; // global locale

var Ls = {}; // global loaded locale

Ls[L] = en;

var isDayjs = function isDayjs(d) {
  return d instanceof Dayjs;
}; // eslint-disable-line no-use-before-define


var parseLocale = function parseLocale(preset, object, isLocal) {
  var l;
  if (!preset) return L;

  if (typeof preset === 'string') {
    if (Ls[preset]) {
      l = preset;
    }

    if (object) {
      Ls[preset] = object;
      l = preset;
    }
  } else {
    var name = preset.name;
    Ls[name] = preset;
    l = name;
  }

  if (!isLocal && l) L = l;
  return l || !isLocal && L;
};

var dayjs = function dayjs(date, c, pl) {
  if (isDayjs(date)) {
    return date.clone();
  } // eslint-disable-next-line no-nested-ternary


  var cfg = c ? typeof c === 'string' ? {
    format: c,
    pl: pl
  } : c : {};
  cfg.date = date;
  return new Dayjs(cfg); // eslint-disable-line no-use-before-define
};

var wrapper = function wrapper(date, instance) {
  return dayjs(date, {
    locale: instance.$L,
    utc: instance.$u,
    $offset: instance.$offset // todo: refactor; do not use this.$offset in you code

  });
};

var Utils = U; // for plugin use

Utils.l = parseLocale;
Utils.i = isDayjs;
Utils.w = wrapper;

var parseDate = function parseDate(cfg) {
  var date = cfg.date,
      utc = cfg.utc;
  if (date === null) return new Date(NaN); // null is invalid

  if (Utils.u(date)) return new Date(); // today

  if (date instanceof Date) return new Date(date);

  if (typeof date === 'string' && !/Z$/i.test(date)) {
    var d = date.match(REGEX_PARSE);

    if (d) {
      if (utc) {
        return new Date(Date.UTC(d[1], d[2] - 1, d[3] || 1, d[4] || 0, d[5] || 0, d[6] || 0, d[7] || 0));
      }

      return new Date(d[1], d[2] - 1, d[3] || 1, d[4] || 0, d[5] || 0, d[6] || 0, d[7] || 0);
    }
  }

  return new Date(date); // everything else
};

var Dayjs = /*#__PURE__*/function () {
  function Dayjs(cfg) {
    this.$L = this.$L || parseLocale(cfg.locale, null, true);
    this.parse(cfg); // for plugin
  }

  var _proto = Dayjs.prototype;

  _proto.parse = function parse(cfg) {
    this.$d = parseDate(cfg);
    this.init();
  };

  _proto.init = function init() {
    var $d = this.$d;
    this.$y = $d.getFullYear();
    this.$M = $d.getMonth();
    this.$D = $d.getDate();
    this.$W = $d.getDay();
    this.$H = $d.getHours();
    this.$m = $d.getMinutes();
    this.$s = $d.getSeconds();
    this.$ms = $d.getMilliseconds();
  } // eslint-disable-next-line class-methods-use-this
  ;

  _proto.$utils = function $utils() {
    return Utils;
  };

  _proto.isValid = function isValid() {
    return !(this.$d.toString() === INVALID_DATE_STRING);
  };

  _proto.isSame = function isSame(that, units) {
    var other = dayjs(that);
    return this.startOf(units) <= other && other <= this.endOf(units);
  };

  _proto.isAfter = function isAfter(that, units) {
    return dayjs(that) < this.startOf(units);
  };

  _proto.isBefore = function isBefore(that, units) {
    return this.endOf(units) < dayjs(that);
  };

  _proto.$g = function $g(input, get, set) {
    if (Utils.u(input)) return this[get];
    return this.set(set, input);
  };

  _proto.year = function year(input) {
    return this.$g(input, '$y', Y);
  };

  _proto.month = function month(input) {
    return this.$g(input, '$M', M);
  };

  _proto.day = function day(input) {
    return this.$g(input, '$W', D);
  };

  _proto.date = function date(input) {
    return this.$g(input, '$D', DATE);
  };

  _proto.hour = function hour(input) {
    return this.$g(input, '$H', H);
  };

  _proto.minute = function minute(input) {
    return this.$g(input, '$m', MIN);
  };

  _proto.second = function second(input) {
    return this.$g(input, '$s', S);
  };

  _proto.millisecond = function millisecond(input) {
    return this.$g(input, '$ms', MS);
  };

  _proto.unix = function unix() {
    return Math.floor(this.valueOf() / 1000);
  };

  _proto.valueOf = function valueOf() {
    // timezone(hour) * 60 * 60 * 1000 => ms
    return this.$d.getTime();
  };

  _proto.startOf = function startOf(units, _startOf) {
    var _this = this; // startOf -> endOf


    var isStartOf = !Utils.u(_startOf) ? _startOf : true;
    var unit = Utils.p(units);

    var instanceFactory = function instanceFactory(d, m) {
      var ins = Utils.w(_this.$u ? Date.UTC(_this.$y, m, d) : new Date(_this.$y, m, d), _this);
      return isStartOf ? ins : ins.endOf(D);
    };

    var instanceFactorySet = function instanceFactorySet(method, slice) {
      var argumentStart = [0, 0, 0, 0];
      var argumentEnd = [23, 59, 59, 999];
      return Utils.w(_this.toDate()[method].apply( // eslint-disable-line prefer-spread
      _this.toDate(), (isStartOf ? argumentStart : argumentEnd).slice(slice)), _this);
    };

    var $W = this.$W,
        $M = this.$M,
        $D = this.$D;
    var utcPad = "set" + (this.$u ? 'UTC' : '');

    switch (unit) {
      case Y:
        return isStartOf ? instanceFactory(1, 0) : instanceFactory(31, 11);

      case M:
        return isStartOf ? instanceFactory(1, $M) : instanceFactory(0, $M + 1);

      case W:
        {
          var weekStart = this.$locale().weekStart || 0;
          var gap = ($W < weekStart ? $W + 7 : $W) - weekStart;
          return instanceFactory(isStartOf ? $D - gap : $D + (6 - gap), $M);
        }

      case D:
      case DATE:
        return instanceFactorySet(utcPad + "Hours", 0);

      case H:
        return instanceFactorySet(utcPad + "Minutes", 1);

      case MIN:
        return instanceFactorySet(utcPad + "Seconds", 2);

      case S:
        return instanceFactorySet(utcPad + "Milliseconds", 3);

      default:
        return this.clone();
    }
  };

  _proto.endOf = function endOf(arg) {
    return this.startOf(arg, false);
  };

  _proto.$set = function $set(units, _int) {
    var _C$D$C$DATE$C$M$C$Y$C; // private set


    var unit = Utils.p(units);
    var utcPad = "set" + (this.$u ? 'UTC' : '');
    var name = (_C$D$C$DATE$C$M$C$Y$C = {}, _C$D$C$DATE$C$M$C$Y$C[D] = utcPad + "Date", _C$D$C$DATE$C$M$C$Y$C[DATE] = utcPad + "Date", _C$D$C$DATE$C$M$C$Y$C[M] = utcPad + "Month", _C$D$C$DATE$C$M$C$Y$C[Y] = utcPad + "FullYear", _C$D$C$DATE$C$M$C$Y$C[H] = utcPad + "Hours", _C$D$C$DATE$C$M$C$Y$C[MIN] = utcPad + "Minutes", _C$D$C$DATE$C$M$C$Y$C[S] = utcPad + "Seconds", _C$D$C$DATE$C$M$C$Y$C[MS] = utcPad + "Milliseconds", _C$D$C$DATE$C$M$C$Y$C)[unit];
    var arg = unit === D ? this.$D + (_int - this.$W) : _int;

    if (unit === M || unit === Y) {
      // clone is for badMutable plugin
      var date = this.clone().set(DATE, 1);
      date.$d[name](arg);
      date.init();
      this.$d = date.set(DATE, Math.min(this.$D, date.daysInMonth())).toDate();
    } else if (name) this.$d[name](arg);

    this.init();
    return this;
  };

  _proto.set = function set(string, _int2) {
    return this.clone().$set(string, _int2);
  };

  _proto.get = function get(unit) {
    return this[Utils.p(unit)]();
  };

  _proto.add = function add(number, units) {
    var _this2 = this,
        _C$MIN$C$H$C$S$unit;

    number = Number(number); // eslint-disable-line no-param-reassign

    var unit = Utils.p(units);

    var instanceFactorySet = function instanceFactorySet(n) {
      var d = dayjs(_this2);
      return Utils.w(d.date(d.date() + Math.round(n * number)), _this2);
    };

    if (unit === M) {
      return this.set(M, this.$M + number);
    }

    if (unit === Y) {
      return this.set(Y, this.$y + number);
    }

    if (unit === D) {
      return instanceFactorySet(1);
    }

    if (unit === W) {
      return instanceFactorySet(7);
    }

    var step = (_C$MIN$C$H$C$S$unit = {}, _C$MIN$C$H$C$S$unit[MIN] = MILLISECONDS_A_MINUTE, _C$MIN$C$H$C$S$unit[H] = MILLISECONDS_A_HOUR, _C$MIN$C$H$C$S$unit[S] = MILLISECONDS_A_SECOND, _C$MIN$C$H$C$S$unit)[unit] || 1; // ms

    var nextTimeStamp = this.$d.getTime() + number * step;
    return Utils.w(nextTimeStamp, this);
  };

  _proto.subtract = function subtract(number, string) {
    return this.add(number * -1, string);
  };

  _proto.format = function format(formatStr) {
    var _this3 = this;

    if (!this.isValid()) return INVALID_DATE_STRING;
    var str = formatStr || FORMAT_DEFAULT;
    var zoneStr = Utils.z(this);
    var locale = this.$locale();
    var $H = this.$H,
        $m = this.$m,
        $M = this.$M;
    var weekdays = locale.weekdays,
        months = locale.months,
        meridiem = locale.meridiem;

    var getShort = function getShort(arr, index, full, length) {
      return arr && (arr[index] || arr(_this3, str)) || full[index].substr(0, length);
    };

    var get$H = function get$H(num) {
      return Utils.s($H % 12 || 12, num, '0');
    };

    var meridiemFunc = meridiem || function (hour, minute, isLowercase) {
      var m = hour < 12 ? 'AM' : 'PM';
      return isLowercase ? m.toLowerCase() : m;
    };

    var matches = {
      YY: String(this.$y).slice(-2),
      YYYY: this.$y,
      M: $M + 1,
      MM: Utils.s($M + 1, 2, '0'),
      MMM: getShort(locale.monthsShort, $M, months, 3),
      MMMM: months[$M] || months(this, str),
      D: this.$D,
      DD: Utils.s(this.$D, 2, '0'),
      d: String(this.$W),
      dd: getShort(locale.weekdaysMin, this.$W, weekdays, 2),
      ddd: getShort(locale.weekdaysShort, this.$W, weekdays, 3),
      dddd: weekdays[this.$W],
      H: String($H),
      HH: Utils.s($H, 2, '0'),
      h: get$H(1),
      hh: get$H(2),
      a: meridiemFunc($H, $m, true),
      A: meridiemFunc($H, $m, false),
      m: String($m),
      mm: Utils.s($m, 2, '0'),
      s: String(this.$s),
      ss: Utils.s(this.$s, 2, '0'),
      SSS: Utils.s(this.$ms, 3, '0'),
      Z: zoneStr // 'ZZ' logic below

    };
    return str.replace(REGEX_FORMAT, function (match, $1) {
      return $1 || matches[match] || zoneStr.replace(':', '');
    }); // 'ZZ'
  };

  _proto.utcOffset = function utcOffset() {
    // Because a bug at FF24, we're rounding the timezone offset around 15 minutes
    // https://github.com/moment/moment/pull/1871
    return -Math.round(this.$d.getTimezoneOffset() / 15) * 15;
  };

  _proto.diff = function diff(input, units, _float) {
    var _C$Y$C$M$C$Q$C$W$C$D$;

    var unit = Utils.p(units);
    var that = dayjs(input);
    var zoneDelta = (that.utcOffset() - this.utcOffset()) * MILLISECONDS_A_MINUTE;
    var diff = this - that;
    var result = Utils.m(this, that);
    result = (_C$Y$C$M$C$Q$C$W$C$D$ = {}, _C$Y$C$M$C$Q$C$W$C$D$[Y] = result / 12, _C$Y$C$M$C$Q$C$W$C$D$[M] = result, _C$Y$C$M$C$Q$C$W$C$D$[Q] = result / 3, _C$Y$C$M$C$Q$C$W$C$D$[W] = (diff - zoneDelta) / MILLISECONDS_A_WEEK, _C$Y$C$M$C$Q$C$W$C$D$[D] = (diff - zoneDelta) / MILLISECONDS_A_DAY, _C$Y$C$M$C$Q$C$W$C$D$[H] = diff / MILLISECONDS_A_HOUR, _C$Y$C$M$C$Q$C$W$C$D$[MIN] = diff / MILLISECONDS_A_MINUTE, _C$Y$C$M$C$Q$C$W$C$D$[S] = diff / MILLISECONDS_A_SECOND, _C$Y$C$M$C$Q$C$W$C$D$)[unit] || diff; // milliseconds

    return _float ? result : Utils.a(result);
  };

  _proto.daysInMonth = function daysInMonth() {
    return this.endOf(M).$D;
  };

  _proto.$locale = function $locale() {
    // get locale object
    return Ls[this.$L];
  };

  _proto.locale = function locale(preset, object) {
    if (!preset) return this.$L;
    var that = this.clone();
    var nextLocaleName = parseLocale(preset, object, true);
    if (nextLocaleName) that.$L = nextLocaleName;
    return that;
  };

  _proto.clone = function clone() {
    return Utils.w(this.$d, this);
  };

  _proto.toDate = function toDate() {
    return new Date(this.valueOf());
  };

  _proto.toJSON = function toJSON() {
    return this.isValid() ? this.toISOString() : null;
  };

  _proto.toISOString = function toISOString() {
    // ie 8 return
    // new Dayjs(this.valueOf() + this.$d.getTimezoneOffset() * 60000)
    // .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
    return this.$d.toISOString();
  };

  _proto.toString = function toString() {
    return this.$d.toUTCString();
  };

  return Dayjs;
}();

dayjs.prototype = Dayjs.prototype;

dayjs.extend = function (plugin, option) {
  plugin(option, Dayjs, dayjs);
  return dayjs;
};

dayjs.locale = parseLocale;
dayjs.isDayjs = isDayjs;

dayjs.unix = function (timestamp) {
  return dayjs(timestamp * 1e3);
};

dayjs.en = Ls[L];
dayjs.Ls = Ls;

var formattingTokens = /(\[[^[]*\])|([-:/.()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g;
var match1 = /\d/; // 0 - 9

var match2 = /\d\d/; // 00 - 99

var match3 = /\d{3}/; // 000 - 999

var match4 = /\d{4}/; // 0000 - 9999

var match1to2 = /\d\d?/; // 0 - 99

var matchUpperCaseAMPM = /[AP]M/;
var matchLowerCaseAMPM = /[ap]m/;
var matchSigned = /[+-]?\d+/; // -inf - inf

var matchOffset = /[+-]\d\d:?\d\d/; // +00:00 -00:00 +0000 or -0000

var matchWord = /\d*[^\s\d-:/.()]+/; // Word

var locale;

function offsetFromString(string) {
  var parts = string.match(/([+-]|\d\d)/g);
  var minutes = +(parts[1] * 60) + +parts[2];
  return minutes === 0 ? 0 : parts[0] === '+' ? -minutes : minutes; // eslint-disable-line no-nested-ternary
}

var addInput = function addInput(property) {
  return function (input) {
    this[property] = +input;
  };
};

var zoneExpressions = [matchOffset, function (input) {
  var zone = this.zone || (this.zone = {});
  zone.offset = offsetFromString(input);
}];
var expressions = {
  A: [matchUpperCaseAMPM, function (input) {
    this.afternoon = input === 'PM';
  }],
  a: [matchLowerCaseAMPM, function (input) {
    this.afternoon = input === 'pm';
  }],
  S: [match1, function (input) {
    this.milliseconds = +input * 100;
  }],
  SS: [match2, function (input) {
    this.milliseconds = +input * 10;
  }],
  SSS: [match3, function (input) {
    this.milliseconds = +input;
  }],
  s: [match1to2, addInput('seconds')],
  ss: [match1to2, addInput('seconds')],
  m: [match1to2, addInput('minutes')],
  mm: [match1to2, addInput('minutes')],
  H: [match1to2, addInput('hours')],
  h: [match1to2, addInput('hours')],
  HH: [match1to2, addInput('hours')],
  hh: [match1to2, addInput('hours')],
  D: [match1to2, addInput('day')],
  DD: [match2, addInput('day')],
  Do: [matchWord, function (input) {
    var _locale = locale,
        ordinal = _locale.ordinal;

    var _input$match = input.match(/\d+/);

    this.day = _input$match[0];
    if (!ordinal) return;

    for (var i = 1; i <= 31; i += 1) {
      if (ordinal(i).replace(/\[|\]/g, '') === input) {
        this.day = i;
      }
    }
  }],
  M: [match1to2, addInput('month')],
  MM: [match2, addInput('month')],
  MMM: [matchWord, function (input) {
    var _locale2 = locale,
        months = _locale2.months,
        monthsShort = _locale2.monthsShort;
    var matchIndex = monthsShort ? monthsShort.findIndex(function (month) {
      return month === input;
    }) : months.findIndex(function (month) {
      return month.substr(0, 3) === input;
    });

    if (matchIndex < 0) {
      throw new Error();
    }

    this.month = matchIndex + 1;
  }],
  MMMM: [matchWord, function (input) {
    var _locale3 = locale,
        months = _locale3.months;
    var matchIndex = months.indexOf(input);

    if (matchIndex < 0) {
      throw new Error();
    }

    this.month = matchIndex + 1;
  }],
  Y: [matchSigned, addInput('year')],
  YY: [match2, function (input) {
    input = +input;
    this.year = input + (input > 68 ? 1900 : 2000);
  }],
  YYYY: [match4, addInput('year')],
  Z: zoneExpressions,
  ZZ: zoneExpressions
};

function correctHours(time) {
  var afternoon = time.afternoon;

  if (afternoon !== undefined) {
    var hours = time.hours;

    if (afternoon) {
      if (hours < 12) {
        time.hours += 12;
      }
    } else if (hours === 12) {
      time.hours = 0;
    }

    delete time.afternoon;
  }
}

function makeParser(format) {
  var array = format.match(formattingTokens);
  var length = array.length;

  for (var i = 0; i < length; i += 1) {
    var token = array[i];
    var parseTo = expressions[token];
    var regex = parseTo && parseTo[0];
    var parser = parseTo && parseTo[1];

    if (parser) {
      array[i] = {
        regex: regex,
        parser: parser
      };
    } else {
      array[i] = token.replace(/^\[|\]$/g, '');
    }
  }

  return function (input) {
    var time = {};

    for (var _i = 0, start = 0; _i < length; _i += 1) {
      var _token = array[_i];

      if (typeof _token === 'string') {
        start += _token.length;
      } else {
        var _regex = _token.regex,
            _parser = _token.parser;
        var part = input.substr(start);

        var match = _regex.exec(part);

        var value = match[0];

        _parser.call(time, value);

        input = input.replace(value, '');
      }
    }

    correctHours(time);
    return time;
  };
}

var parseFormattedInput = function parseFormattedInput(input, format, utc) {
  try {
    var parser = makeParser(format);

    var _parser2 = parser(input),
        year = _parser2.year,
        month = _parser2.month,
        day = _parser2.day,
        hours = _parser2.hours,
        minutes = _parser2.minutes,
        seconds = _parser2.seconds,
        milliseconds = _parser2.milliseconds,
        zone = _parser2.zone;

    if (zone) {
      return new Date(Date.UTC(year, month - 1, day, hours || 0, minutes || 0, seconds || 0, milliseconds || 0) + zone.offset * 60 * 1000);
    }

    var now = new Date();
    var d = day || (!year && !month ? now.getDate() : 1);
    var y = year || now.getFullYear();
    var M = month > 0 ? month - 1 : now.getMonth();
    var h = hours || 0;
    var m = minutes || 0;
    var s = seconds || 0;
    var ms = milliseconds || 0;

    if (utc) {
      return new Date(Date.UTC(y, M, d, h, m, s, ms));
    }

    return new Date(y, M, d, h, m, s, ms);
  } catch (e) {
    return new Date(''); // Invalid Date
  }
};

var customParseFormat = (function (o, C, d) {
  var proto = C.prototype;
  var oldParse = proto.parse;

  proto.parse = function (cfg) {
    var date = cfg.date,
        format = cfg.format,
        pl = cfg.pl,
        utc = cfg.utc;
    this.$u = utc;

    if (format) {
      locale = pl ? d.Ls[pl] : this.$locale();
      this.$d = parseFormattedInput(date, format, utc);
      this.init(cfg);
      if (pl) this.$L = pl;
    } else {
      oldParse.call(this, cfg);
    }
  };
});

function formatDate(value, locale, format) {
  dayjs.extend(customParseFormat);
  var dt = new Date(value);

  if (format) {
    return dayjs(dt).format(format);
  }

  return dt.toLocaleDateString(locale);
}
function formatDateTime(value, locale, format) {
  dayjs.extend(customParseFormat);
  var dt = new Date(value);

  if (format) {
    return dayjs(dt).format(format);
  }

  return dt.toLocaleString(locale);
}

function getValue(tableContext, prop, data, key, value, id, classes) {
  if (value === null && value === undefined | key !== 'actions') {
    return h("span", null);
  } else {
    var locale = tableContext.store.state.locale;
    var dateFormat = tableContext.store.state.dateFormat;
    var dateTimeFormat = tableContext.store.state.dateTimeFormat;

    if (isDateTimeType(prop)) {
      return formatDateTime(value, locale, dateTimeFormat);
    } else if (isDateType(prop)) {
      return formatDate(value, locale, dateFormat);
    } else if (isEmailType(prop)) {
      return Mailto(value);
    } else if (isUriType(prop)) {
      return Hyperlink(value);
    } else if (prop.type === 'number' && prop.format && prop.format === 'currency') {
      return Currency(tableContext, value, prop.decimal);
    } else if (prop.type === 'number' && prop.decimal && prop.decimal > 0) {
      return value.toFixed(prop.decimal);
    } else if (prop.type === 'boolean' && prop.format && prop.format === 'checkbox') {
      return Checkbox(tableContext, data, key, value, id, prop.editable);
    } else if (prop.type === 'boolean' && prop.format && prop.format === 'icon') {
      return Icon(tableContext, value);
    } else if (prop.type === 'boolean' && prop.format && prop.format === 'string') {
      return value ? 'Yes' : 'No';
    } else if (prop.type === 'array' && prop.format && prop.format === 'select') {
      return Select(tableContext, data, key, value, id, prop.editable);
    } else if (prop.type === 'string' && prop.format && prop.format === 'button') {
      var buttonValue = value;

      if (_typeof(value) === 'object' && (value.disabled != null || value.hidden != null || value.value != null)) {
        buttonValue = {};
        buttonValue[key] = value;
      }

      return Button(tableContext, prop, data, key, buttonValue, id, classes);
    } else if (_typeof(prop) === 'object' && prop.properties) {
      return h("div", {
        "class": "d-flex"
      }, Object.keys(prop.properties).map(function (k, i) {
        return getValue(tableContext, prop.properties[k], data, k, value, id, i > 0 ? 'ml-1' : null);
      }));
    } else {
      return value;
    }
  }
}

var Value = function Value(tableContext, data, key, value, id) {
  var prop = tableContext.store.state.schema.properties[key];

  if (tableContext.store.state.cellTemplates && tableContext.store.state.cellTemplates[key]) {
    var rt = tableContext.store.state.cellTemplates[key];
    var cell = resolveToString(rt, data);
    return elementFromString(cell);
  }

  return getValue(tableContext, prop, data, key, value, id);
};

var ClassBuilder = /*#__PURE__*/function () {
  function ClassBuilder() {
    _classCallCheck(this, ClassBuilder);

    this.classes = [];
  }

  _createClass(ClassBuilder, [{
    key: "addClass",
    value: function addClass(className) {
      this.classes.push(className);
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      if (this.classes.length === 1) {
        return this.classes[0];
      }

      return this.classes.join(' ');
    }
  }]);

  return ClassBuilder;
}();

function addClasses(classes, element) {
  classes.forEach(function (x) {
    return addClass(x, element);
  });
}
function addClass(className, element) {
  if (element.classList) {
    element.classList.add(className);
  } else {
    var classes = element.getAttribute('class').split(' ');

    if (!classes.includes(className)) {
      classes.push(className);
      element.setAttribute('class', classes.join(' '));
    }
  }

  return element;
}

function removeClasses(classes, element) {
  classes.forEach(function (x) {
    return removeClass(x, element);
  });
}
function removeClass(className, element) {
  if (element.classList) {
    element.classList.remove(className);
  } else {
    var classes = element.getAttribute('class').split(' ');
    classes.splice(classes.indexOf(className), 1);
    element.setAttribute('class', classes.join(' '));
  }

  return element;
}

function getOnInlineEditChange(tableContext, data, key, id, cellId) {
  return function (e) {
    callOnBeforeChange(tableContext, data, key, id, cellId, e.target);
  };
}

function getOnInlineEditInputKeydown(tableContext, data, key, id, cellId) {
  return function (e) {
    if ((e.which || e.keyCode) && (e.which === 13 || e.keyCode === 13)) {
      callOnBeforeChange(tableContext, data, key, id, cellId, e.target, true);
    } else if ((e.which || e.keyCode) && (e.which === 27 || e.keyCode === 27)) {
      toggleInlineEdit(cellId, false, e.target);
    }
  };
}

var InlineEditInput = function InlineEditInput(tableContext, data, key, id, cellId, type, attrs) {
  return h("input", _extends({
    type: type,
    onchange: getOnInlineEditChange(tableContext, data, key, id, cellId),
    onkeydown: getOnInlineEditInputKeydown(tableContext, data, key, id, cellId),
    "class": "inline-cell-edit"
  }, attrs));
};

function replaceChild(newChild, oldChild, node) {
  if (Array.isArray(newChild)) {
    for (var i = 0; i < newChild.length; i++) {
      node.replaceChild(newChild[i], oldChild[i]);
    }
  } else {
    node.replaceChild(newChild, oldChild);
  }
}

function isInlineEditing(id) {
  var cell = document.getElementById(id);
  return cell.classList.contains('inline-editing');
}

function isDisabled(id) {
  var cell = document.getElementById(id);
  return cell.parentNode.classList.contains('disabled');
}

function getInputType(prop) {
  if (isDateTimeType(prop)) {
    return 'datetime-local';
  }

  if (isDateType(prop)) {
    return 'date';
  }

  if (isNumberType(prop)) {
    return 'number';
  }

  if (isEmailType(prop)) {
    return 'email';
  }

  if (isUriType(prop)) {
    return 'url';
  }

  if (isBooleanType(prop)) {
    return 'checkbox';
  }

  return 'text';
}

function toggleInlineEdit(id, show, input, value) {
  var editingClasses = ['inline-editing', 'align-middle', 'p-0'];
  var cell = document.getElementById(id);
  var cd = cell.querySelector('div');

  if (show) {
    cell.style.width = "".concat(cell.clientWidth, "px");
    addClasses(editingClasses, cell);
    addClasses(['d-none'], cd);
    input.type === 'checkbox' ? input.checked = value : input.value = value;
    cell.appendChild(input);
    setTimeout(function () {
      input.focus();
      input.select();
    }, 100);
  } else {
    removeClasses(editingClasses, cell);
    removeClasses(['d-none'], cd);
    cell.removeChild(input);
    cell.style.width = null;
  }
}
function setInlineEditInvalid(id) {
  var cell = document.getElementById(id);
  var input = cell.querySelector('input');
  input.classList.add('is-invalid');
}

function getCellValue(tableContext, prop, data) {
  var locale = tableContext.store.state.locale;

  if (isDateTimeType(prop)) {
    return formatDateTime(data, locale, 'YYYY-MM-DDTHH:mm');
  }

  if (isDateType(prop)) {
    return formatDateTime(data, locale, 'YYYY-MM-DD');
  }

  if (isNumberType(prop) && prop.decimal && prop.decimal > 0) {
    return Number(data).toLocaleString(locale, {
      minimumFractionDigits: prop.decimal,
      maximumFractionDigits: prop.decimal
    });
  }

  return data;
}

function parseInputValue(tableContext, key, input) {
  var prop = tableContext.store.state.schema.properties[key];

  if (isNumberType(prop)) {
    return Number(input.value);
  }

  if (isBooleanType(prop)) {
    return input.checked;
  }

  return input.value;
}

function replaceRow(tableContext, id) {
  var index = getRowIndex(tableContext, id);
  var nr = getRowData(tableContext, index);
  var or = tableContext.element.querySelector("#row-".concat(id));
  var tbody = tableContext.element.querySelector('tbody');
  replaceChild(nr, or, tbody);
}

function getInputAttributes(prop) {
  if (isNumberType(prop) && prop.decimal && prop.decimal > 0) {
    return {
      step: '0.01'
    };
  }

  return undefined;
}

function getOnCellDoubleClick(tableContext, data, key, id, cellId, prop) {
  var input = InlineEditInput(tableContext, data, key, id, cellId, getInputType(prop), getInputAttributes(prop));
  return function () {
    if (!isInlineEditing(cellId) && !isDisabled(cellId)) {
      toggleInlineEdit(cellId, true, input, getCellValue(tableContext, prop, data[key]));
    }
  };
}
function triggerOnAction(tableContext, cellId, id, input, value, key, rowData) {
  var onAction = tableContext.store.state.onAction;
  var index = getRowIndex(tableContext, id);

  if (onAction) {
    onAction(tableContext.table, 'inlineEdit', [{
      index: index,
      rowData: rowData,
      value: value
    }]);
  } else {
    setRowData(tableContext, index, rowData, false);
  }
}
function callOnBeforeChange(tableContext, data, key, id, cellId, input) {
  var hideInlineEdit = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var onBeforeChange = tableContext.store.state.onBeforeChange;
  var value = parseInputValue(tableContext, key, input);

  var newRowData = _objectSpread2({}, data, _defineProperty({}, key, value));

  if (onBeforeChange) {
    var oldRowData = _objectSpread2({}, data);

    var res = onBeforeChange(tableContext.table, key, value, oldRowData, newRowData);

    if ((_typeof(res) === 'object' || typeof res === 'function') && typeof res.then === 'function') {
      res.then(function () {
        triggerOnAction(tableContext, cellId, id, input, value, key, newRowData);

        if (hideInlineEdit) {
          replaceRow(tableContext, id);
        }
      })["catch"](function () {
        setInlineEditInvalid(cellId);
      });
    } else if (res) {
      triggerOnAction(tableContext, cellId, id, input, value, key, newRowData);

      if (hideInlineEdit) {
        replaceRow(tableContext, id);
      }
    } else if (!res) {
      setInlineEditInvalid(cellId);
    } else {
      throw new Error('onBeforeChange function did not return a Promise or boolean!');
    }
  } else {
    triggerOnAction(tableContext, cellId, id, input, value, key, newRowData);

    if (hideInlineEdit) {
      replaceRow(tableContext, id);
    }
  }
}

var EmptyTableRow = function EmptyTableRow(l) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return h("tr", null, h("td", _extends({
    colspan: l
  }, attrs), c));
};

function hasChildRow(state) {
  return state.childTable && typeof state.childTable === 'function';
}
function toggleChildTable(store, index) {
  var row = store.state.cache[index].row;

  if (Array.isArray(row)) {
    var button = row[0].querySelector('.cell-collapse button');

    if (button) {
      button.click();
    }
  }
}

function isExpanded(store, index) {
  var row = store.state.cache[index].row;

  if (Array.isArray(row)) {
    var button = row[0].querySelector('.cell-collapse button');
    return button.getAttribute('aria-expanded') === 'true';
  }

  return false;
}

function hideChildTables(store) {
  if (hasChildRow(store.state)) {
    var _getRange = getRange(store),
        start = _getRange.start,
        limit = _getRange.limit;

    for (var i = start; i < limit; i++) {
      if (isExpanded(store, i)) {
        toggleChildTable(store, i);
      }
    }
  }
}

/** @jsx h */
var columnClasses = {
  'checkbox': 'text-center'
};

function filteredHeaders(tableContext) {
  return Object.keys(tableContext.store.state.schema.properties).filter(function (key) {
    return !isSchema(key, tableContext.store.state.schema.properties[key]);
  });
}

var buildColumnClasses = function buildColumnClasses(prop) {
  var cb = new ClassBuilder();
  cb.addClass('text-nowrap');
  prop.align && cb.addClass("text-".concat(prop.align));
  prop.valign && cb.addClass("align-".concat(prop.valign));
  prop.hidden && cb.addClass('d-none');
  prop.editable && prop.format !== 'checkbox' && cb.addClass('cell-editable pr-4');
  !prop.hidden && cb.addClass(columnClasses[prop.format]);
  prop.format === 'select' && cb.addClass('p-0');
  return cb.build();
};

var CreateChildTableRow = function CreateChildTableRow(tableContext, data, id) {
  if (!hasChildRow(tableContext.store.state)) {
    throw new Error('childTable function is required for children data');
  }

  return EmptyTableRow(filteredHeaders(tableContext).length + 1, {
    id: "collapse-row-".concat(id),
    "class": 'text-center d-none is-loading'
  }, elementFromString(tableContext.store.state.loadingTemplate));
};

var TableCell = function TableCell(tableContext, data, id, key) {
  var prop = tableContext.store.state.schema.properties[key];
  var cc = buildColumnClasses(prop);

  if (prop.editable && prop.format !== 'checkbox') {
    var cellId = "cell-".concat(key, "-").concat(id);
    var enableDoubleClick = prop.format !== 'select';
    return h("td", {
      "class": cc,
      "data-prop": key,
      id: cellId,
      ondblclick: enableDoubleClick ? getOnCellDoubleClick(tableContext, data, key, id, cellId, prop) : null
    }, h("div", null, Value(tableContext, data, key, data[key], id)));
  } else {
    return h("td", {
      "class": cc,
      "data-prop": key
    }, Value(tableContext, data, key, data[key], id));
  }
};

var BodyRow = function BodyRow(tableContext, data, id) {
  return h("tr", {
    id: "row-".concat(id),
    "class": data[tableContext.store.state.rowStatusKey] ? "status status-".concat(data[tableContext.store.state.rowStatusKey]) : ''
  }, filteredHeaders(tableContext).map(function (key) {
    return TableCell(tableContext, data, id, key);
  }));
};

function getOnClick$1(tableContext, id, collapseId, index) {
  return function (e) {
    var row = document.getElementById(collapseId);

    if (row) {
      row.classList.toggle('d-none');
      var expanded = e.target.getAttribute('aria-expanded');
      e.target.setAttribute('aria-expanded', expanded === 'true' ? 'false' : 'true'); // load the child data if we need to

      if (row.classList.contains('is-loading')) {
        loadChildTable(tableContext, index, row);
      }
    }
  };
}

var BodyRowWithCollapse = function BodyRowWithCollapse(tableContext, data, id, collapseId, index) {
  var expanded = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  return h("tr", {
    id: "row-".concat(id),
    "class": data[tableContext.store.state.rowStatusKey] ? "status status-".concat(data[tableContext.store.state.rowStatusKey]) : ''
  }, h("td", {
    "class": "cell-collapse"
  }, h("button", {
    type: "button",
    "class": "btn btn-link",
    onclick: getOnClick$1(tableContext, id, collapseId, index),
    "aria-expanded": expanded
  }, h("svg", {
    width: "18",
    height: "18",
    "class": "icon fill-secondary"
  }, h("use", {
    href: "#table_angle_right",
    xlinkHref: "#table_angle_right"
  })))), filteredHeaders(tableContext).map(function (key) {
    return TableCell(tableContext, data, id, key);
  }));
};

function ChildTableRow(tableContext, data, id, index, expanded) {
  var collapseId = "collapse-row-".concat(id);
  return [BodyRowWithCollapse(tableContext, data, id, collapseId, index, expanded), CreateChildTableRow(tableContext, data, id)];
}

/** @jsx h */

var buildTableClasses = function buildTableClasses(s) {
  var cb = new ClassBuilder();
  s.striped && cb.addClass('table-striped');
  s.bordered && cb.addClass('table-bordered');
  s.dark && cb.addClass('table-dark');
  s.hover && cb.addClass('table-hover');
  s.small && cb.addClass('table-sm');
  return cb.build();
};

var TableHead = function TableHead(s) {
  return s.headClassName ? h("thead", {
    "class": s.headClassName
  }) : h("thead", null);
};

var TableFoot = function TableFoot(s) {
  return s.footClassName ? h("tfoot", {
    "class": s.footClassName
  }) : h("tfoot", null);
};

var ResponsiveTable = function ResponsiveTable(s) {
  return h("div", {
    "class": "table-responsive"
  }, Table(s));
};

var Table = function Table(s) {
  return h("table", {
    id: s.id,
    "class": "table ".concat(buildTableClasses(s)),
    style: "table-layout: ".concat(s.layout, "; width: ").concat(s.width)
  }, TableHead(s), h("tbody", null), s.footers ? TableFoot(s) : '');
};

var DefaultTable = function DefaultTable(s) {
  return s.fixedHeight ? Table(s) : ResponsiveTable(s);
};

/** @jsx h */

function isStandardPageSize(size) {
  var pg = [10, 25, 50];
  return pg.indexOf(parseInt(size, 10)) !== -1;
}

var DisplayedEntries = function DisplayedEntries(s) {
  return h("span", {
    "class": "ml-4"
  }, h("span", {
    "class": "mr-1"
  }, "Display"), h("select", {
    "class": "form-control d-inline-block w-auto",
    size: "1"
  }, h("option", {
    value: "10",
    selected: s.state.pageSize === 10
  }, "10"), h("option", {
    value: "25",
    selected: s.state.pageSize === 25
  }, "25"), h("option", {
    value: "50",
    selected: s.state.pageSize === 50
  }, "50"), s.originalOptions.pageSize && !isStandardPageSize(s.originalOptions.pageSize) && h("option", {
    value: s.originalOptions.pageSize,
    selected: s.state.pageSize === s.originalOptions.pageSize
  }, s.originalOptions.pageSize)), h("span", {
    "class": "ml-1"
  }, "rows"));
};

/** @jsx h */
var FixedHeightTable = function FixedHeightTable(s) {
  return h("div", {
    "class": "tfh-c tfh-h tfh-f".concat(s.footers ? ' mb-3' : '')
  }, h("div", {
    "class": "tfh"
  }, DefaultTable(s)));
};

/** @jsx h */

function getTitle(key, value, state) {
  var title = value && value.title || key;
  return h("div", {
    "class": "d-flex justify-content-center flex-column flex-fill py-1"
  }, h("span", {
    "class": "title p-0 text-nowrap",
    title: state && state.searchEnabled ? "Search term: ".concat(key) : ''
  }, title), h("span", {
    "class": "key d-none"
  }, key));
}

var Title = function Title(key, schemaProps, state) {
  return getTitle(key, schemaProps[key], state);
};

var ColumnSearch = function ColumnSearch(key, state, onInput, onKeydown) {
  var inputAttributes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  // work around to tab focus issue when there is ie 11 as its not support placeholder and focus hence remove attribute.
  var isIe = !!window.MSInputMethodContext && !!document.documentMode;

  if (isIe && inputAttributes && inputAttributes.placeholder) {
    delete inputAttributes.placeholder;
  }

  return h("div", {
    "class": "pt-0 pb-1"
  }, h("input", _extends({
    type: "search",
    "class": "form-control".concat(state.small ? ' form-control-sm' : ''),
    id: "column-search-".concat(state.id, "-").concat(key),
    value: state.searchColumns && state.searchColumns[key] && state.searchColumns[key].query,
    oninput: function oninput(e) {
      e.preventDefault();
      e.stopPropagation();
      onInput(key, e);
    },
    onkeydown: function onkeydown(e) {
      onKeydown(key, e);
    }
  }, inputAttributes)));
};

function getSortIcon(key, state) {
  var icon = '#table_sort';
  var title = 'Sort column';

  if (key === state.sortHeader) {
    icon = state.sortDirection === 'desc' ? '#table_sort_desc' : '#table_sort_asc';
    title = state.sortDirection === 'desc' ? 'Column sorted in descending order' : 'Column sorted in ascending order';
  }

  return [icon, title];
}

var SortIndicator = function SortIndicator(key, state, onClick) {
  var _getSortIcon = getSortIcon(key, state),
      _getSortIcon2 = _slicedToArray(_getSortIcon, 2),
      icon = _getSortIcon2[0],
      title = _getSortIcon2[1];

  return h("button", {
    "class": "btn mc-btn__button mc-btn__button--link btn-link p-1",
    "data-header": key,
    tabindex: "-1",
    onclick: function onclick() {
      return onClick(key);
    },
    "aria-label": title
  }, h("svg", {
    "class": "icon mr-0 fill-secondary",
    width: "18",
    height: "18"
  }, h("title", null, title), h("use", {
    xlinkHref: icon,
    href: icon
  })));
};

/** @jsx h */
var SelectAllCheckbox = function SelectAllCheckbox(onSelectAll, k) {
  return h("input", {
    type: "checkbox",
    "class": "ml-1",
    onclick: function onclick(e) {
      return onSelectAll(e, k);
    }
  });
};

/** @jsx h */

var buildHeaderClasses = function buildHeaderClasses(s, cs) {
  var cb = new ClassBuilder();
  cb.addClass('align-top py-0 text-left');
  s.hidden && cb.addClass('d-none');
  s.sortable && cb.addClass('pr-0');
  !s.sortable && cs && cb.addClass('table-head-title');
  return cb.build();
};

var getTitleAndActions = function getTitleAndActions(hasCheckbox, sortable, key, schemaProps, state, onClick, onSelectAll) {
  if (hasCheckbox && sortable) {
    return h("div", {
      "class": "d-flex flex-grow-1 align-items-center"
    }, Title(key, schemaProps, state), h("div", null, SelectAllCheckbox(onSelectAll, key), SortIndicator(key, state, onClick)));
  } else if (!hasCheckbox && sortable) {
    return h("div", {
      "class": "d-flex flex-grow-1 align-items-center"
    }, Title(key, schemaProps, state), SortIndicator(key, state, onClick));
  } else if (hasCheckbox && !sortable) {
    return h("div", {
      "class": "d-flex flex-grow-1 align-items-center"
    }, Title(key, schemaProps, state), SelectAllCheckbox(onSelectAll, key));
  } else {
    return Title(key, schemaProps, state);
  }
};

var getHeader = function getHeader(columnSearch, key, schemaProps, state, onClick, onInput, onKeydown, onSelectAll) {
  var sortable = schemaProps && schemaProps[key] && schemaProps[key].sortable;
  var isBoolean = schemaProps && schemaProps[key] && schemaProps[key].type === 'boolean';
  var hasCheckbox = isBoolean && schemaProps[key].format === 'checkbox' && schemaProps[key].editable;
  var hasColumnSearch = columnSearch;

  if (schemaProps[key].hasOwnProperty('columnSearch')) {
    hasColumnSearch = schemaProps[key].columnSearch;
  }

  if (hasColumnSearch && !isBoolean && key !== 'actions') {
    return h("div", null, h("div", {
      "class": "d-flex".concat(sortable ? ' justify-content-between' : '')
    }, getTitleAndActions(hasCheckbox, sortable, key, schemaProps, state, onClick, onSelectAll)), h("div", {
      style: sortable ? 'padding-right: .75rem' : ''
    }, ColumnSearch(key, state, onInput, onKeydown, state.columnSearchInputAttributes)));
  } else {
    return h("div", null, h("div", {
      "class": "d-flex".concat(sortable ? ' justify-content-between' : '')
    }, getTitleAndActions(hasCheckbox, sortable, key, schemaProps, state, onClick, onSelectAll)));
  }
};

function HeadRow(columnSearch, containsColumnSortOrSearch, hasChildRow, schemaProps, schemaPropKeys, state, onClick, onInput, onKeydown, onSelectAll) {
  if (hasChildRow) {
    return h("tr", null, h("th", null, "\xA0"), schemaPropKeys.filter(function (key) {
      return !isSchema(key, schemaProps[key]);
    }).map(function (key) {
      return h("th", {
        "data-prop": key,
        "class": buildHeaderClasses(schemaProps[key], containsColumnSortOrSearch)
      }, getHeader(columnSearch, key, schemaProps, state, onClick, onInput, onKeydown, onSelectAll));
    }));
  } else {
    return h("tr", null, schemaPropKeys.filter(function (key) {
      return !isSchema(key, schemaProps[key]);
    }).map(function (key) {
      return h("th", {
        "data-prop": key,
        "class": buildHeaderClasses(schemaProps[key], containsColumnSortOrSearch)
      }, getHeader(columnSearch, key, schemaProps, state, onClick, onInput, onKeydown, onSelectAll));
    }));
  }
}

/** @jsx h */

var getColumnClass = function getColumnClass(s) {
  return s.hidden ? 'd-none' : '';
};

var FootRow = function FootRow(fixedHeight, schemaProps, schemaPropKeys) {
  return h("tr", null, schemaPropKeys.filter(function (key) {
    return !isSchema(key, schemaProps[key]);
  }).map(function (k) {
    return h("th", {
      "class": getColumnClass(schemaProps[k])
    }, Title(k, schemaProps));
  }));
};

var FullTextSearch = function FullTextSearch(id, placeholder, onInput) {
  var inputAttributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return h("div", {
    "class": "pb-2"
  }, h("div", {
    "class": "form-group my-2"
  }, h("label", {
    "class": "font-weight-bold sr-only",
    "for": "".concat(id, "-input")
  }, "Label for full-text-search-input"), h("input", _extends({
    type: "search",
    id: "".concat(id, "-input"),
    "class": "form-control",
    placeholder: placeholder,
    oninput: function oninput(e) {
      e.preventDefault();
      e.stopPropagation();
      onInput(e);
    },
    onkeydown: onInput
  }, inputAttributes))));
};

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/** @jsx h */
var PaginationList = function PaginationList(s) {
  return h("ul", {
    "class": "pagination mb-0 float-right"
  }, h("li", {
    "class": "page-item".concat(!s.isTherePreviousPage ? ' disabled' : '')
  }, h("a", {
    id: "previous-link-".concat(s.id),
    "class": "page-link",
    href: "#",
    tabindex: !s.isTherePreviousPage ? -1 : 0,
    "aria-label": "Previous"
  }, "Previous")), s.pageIndices.map(function (i) {
    return h("li", {
      "class": "page-item".concat(i === s.currentPageIndex ? ' active' : '')
    }, h("a", {
      "class": "page-link goto-link-".concat(s.id),
      href: "#",
      "data-page-index": s.pageIndex,
      "data-goto-page-index": i
    }, numberWithCommas(i + 1)));
  }), h("li", {
    "class": "page-item".concat(!s.isThereNextPage ? ' disabled' : '')
  }, h("a", {
    id: "next-link-".concat(s.id),
    "class": "page-link",
    href: "#",
    tabindex: !s.isThereNextPage ? -1 : 0,
    "aria-label": "Next"
  }, "Next")));
};
var Pagination = function Pagination(s) {
  return h("nav", {
    "aria-label": "Table pagination",
    id: "pagination-container-".concat(s.id),
    "class": "pagination-container mb-3 clearfix"
  }, h("div", {
    "class": "row"
  }, h("div", {
    "class": "col-sm"
  }, h("span", {
    id: "pagination-info-".concat(s.id),
    "class": "mr-2"
  }, PaginationInfo(s)), h("span", {
    "class": "displayed-entries"
  }, "\xA0")), h("div", {
    id: "pagination-list-".concat(s.id),
    "class": "col-sm"
  }, PaginationList(s))));
};
var PaginationInfo = function PaginationInfo(s) {
  return h("span", null, s.info);
};

var Table$1 = function Table(s) {
  return s.fixedHeight ? FixedHeightTable(s) : DefaultTable(s);
};

/** @jsx h */
function Icons() {
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "class": "svg-hidden"
  }, h("symbol", {
    id: "table_sort",
    viewBox: "0 0 32 32"
  }, h("path", {
    d: "M 16 3.59375 L 15.28125 4.28125 L 7.28125 12.28125 L 5.59375 14 L 26.40625 14 L 24.71875 12.28125 L 16.71875 4.28125 Z M 16 6.4375 L 21.5625 12 L 10.4375 12 Z M 5.59375 18 L 7.28125 19.71875 L 15.28125 27.71875 L 16 28.40625 L 16.71875 27.71875 L 24.71875 19.71875 L 26.40625 18 Z M 10.4375 20 L 21.5625 20 L 16 25.5625 Z "
  })), h("symbol", {
    id: "table_sort_asc",
    viewBox: "0 0 32 32"
  }, h("path", {
    d: "M 16 8.59375 L 15.28125 9.28125 L 5.28125 19.28125 L 3.59375 21 L 28.40625 21 L 26.71875 19.28125 L 16.71875 9.28125 Z M 16 11.4375 L 23.5625 19 L 8.4375 19 Z "
  })), h("symbol", {
    id: "table_sort_desc",
    viewBox: "0 0 32 32"
  }, h("path", {
    d: "M 3.59375 12 L 5.28125 13.71875 L 15.28125 23.71875 L 16 24.40625 L 16.71875 23.71875 L 26.71875 13.71875 L 28.40625 12 Z M 8.4375 14 L 23.5625 14 L 16 21.5625 Z "
  })), h("symbol", {
    id: "table_checkmark",
    viewBox: "0 0 32 32"
  }, h("path", {
    d: "M 28.28125 6.28125 L 11 23.5625 L 3.71875 16.28125 L 2.28125 17.71875 L 10.28125 25.71875 L 11 26.40625 L 11.71875 25.71875 L 29.71875 7.71875 Z "
  })), h("symbol", {
    id: "table_angle_right",
    viewBox: "0 0 32 32"
  }, h("path", {
    d: "M 12.96875 4.28125 L 11.53125 5.71875 L 21.8125 16 L 11.53125 26.28125 L 12.96875 27.71875 L 23.96875 16.71875 L 24.65625 16 L 23.96875 15.28125 Z "
  })), h("symbol", {
    id: "table_angle_down",
    viewBox: "0 0 32 32"
  }, h("path", {
    d: "M 4.21875 10.78125 L 2.78125 12.21875 L 15.28125 24.71875 L 16 25.40625 L 16.71875 24.71875 L 29.21875 12.21875 L 27.78125 10.78125 L 16 22.5625 Z "
  })), h("symbol", {
    id: "table_delete_sign",
    viewBox: "0 0 32 32"
  }, h("path", {
    d: "M 7.21875 5.78125 L 5.78125 7.21875 L 14.5625 16 L 5.78125 24.78125 L 7.21875 26.21875 L 16 17.4375 L 24.78125 26.21875 L 26.21875 24.78125 L 17.4375 16 L 26.21875 7.21875 L 24.78125 5.78125 L 16 14.5625 Z "
  })));
}

function isValidData(data) {
  return isArray$1(data) || isObject$1(data);
}
function isArray$1(data) {
  return Array.isArray(data);
}
function isObject$1(obj) {
  return _typeof(obj) === 'object' && obj.hasOwnProperty('totalCount') && obj.hasOwnProperty('data') && isArray$1(obj.data);
}

function createMatcher(store, st, query) {
  if (isNumberType(st)) {
    return createNumberQueryMatcher(query);
  } else if (isBooleanType(st)) {
    return createBooleanQueryMatcher(query);
  } else if (isDateType(st)) {
    return createDateQueryMatcher(query, store.state.dateFormat);
  } else if (isDateTimeType(st)) {
    return createDateQueryMatcher(query, store.state.dateTimeFormat);
  } else if (isStringType(st)) {
    return createStringQueryMatcher(query, store.state.columnSearchCaseSensitive);
  } else {
    return createDefaultQueryMatcher(query);
  }
}
function parseQuery(store, query) {
  var tokens = query.split(' ');
  var matchers = {};
  var text = [];
  tokens.forEach(function (t) {
    if (/:/.test(t)) {
      var _t$split = t.split(':'),
          _t$split2 = _slicedToArray(_t$split, 2),
          k = _t$split2[0],
          q = _t$split2[1];

      var st = store.state.schema.properties[k];
      matchers[k] = createMatcher(store, st, q);
    } else {
      text.push(query);
    }
  });

  if (text.length > 0) {
    matchers['*'] = createStringQueryMatcher(text.join(' '));
  }

  return function (data) {
    var match = false;
    Object.keys(data).forEach(function (k) {
      if (matchers[k]) {
        var d = data[k];
        match = matchers[k](d);
      } else if (!matchers[k] && matchers['*']) {
        var _d = data[k];
        match = matchers['*'](_d);
      }
    });
    return match;
  };
}

function createStringQueryMatcher(query, caseSensitive) {
  var mr = null;
  var q = query;
  var exclude = false;
  var regFlags = caseSensitive === true ? '' : 'i';

  if (/^!/.test(q)) {
    q = query.substring(1);
    exclude = true;
  }

  if (/^~/.test(q)) {
    mr = new RegExp(q.substring(1), regFlags);
  } else if (/^=/.test(q)) {
    mr = new RegExp("^".concat(q.substring(1), "$"));
  } else {
    mr = new RegExp(q, regFlags);
  }

  return function (data) {
    return exclude ? !mr.test(data) : mr.test(data);
  };
}

function createNumberQueryMatcher(query) {
  var q = query;
  var exclude = false;

  if (/^!/.test(q)) {
    q = query.substring(1);
    exclude = true;
  }

  if (/^</.test(q)) {
    q = parseFloat(q.substring(1));
    return function (data) {
      var d = parseFloat(data);
      return d < q;
    };
  } else if (/^>/.test(q)) {
    q = parseFloat(q.substring(1));
    return function (data) {
      var d = parseFloat(data);
      return d > q;
    };
  } else if (/\.\.\./.test(query)) {
    var _query$split = query.split('...'),
        _query$split2 = _slicedToArray(_query$split, 2),
        n1 = _query$split2[0],
        n2 = _query$split2[1];

    var q1 = parseFloat(n1);
    var q2 = parseFloat(n2);
    return function (data) {
      var d = parseFloat(data);
      return d >= q1 && d <= q2;
    };
  } else if (/^=/.test(q)) {
    q = q.substring(1);
  }

  q = parseFloat(q);
  return function (data) {
    var d = parseFloat(data);
    return exclude ? d !== q : d === q;
  };
}

function createBooleanQueryMatcher(query) {
  var q = null;

  if (/^=/.test(query)) {
    q = !!query.substring(1);
  } else {
    q = !!query;
  }

  return function (data) {
    var d = !!data;
    return d === q;
  };
}

function parseDate$1(data, format) {
  var t = dayjs(data); // convert to ISO date from table data

  var d = dayjs(t).format(format); // now convert to search date/datetime format

  return dayjs(d, format); // convert back to ISO date, having taken into account search format
}

function createDateQueryMatcher(query, format) {
  dayjs.extend(customParseFormat);
  var fallback = createDefaultQueryMatcher(query);

  if (!format) {
    return fallback;
  }

  var q = query;
  var exclude = false;

  if (/^!/.test(q)) {
    q = query.substring(1);
    exclude = true;
  }

  if (/\.\.\./.test(q)) {
    var _q$split = q.split('...'),
        _q$split2 = _slicedToArray(_q$split, 2),
        d1 = _q$split2[0],
        d2 = _q$split2[1];

    try {
      var p1 = dayjs(d1, format);
      var p2 = dayjs(d2, format);
      return function (data) {
        var d = parseDate$1(data, format);
        return d.valueOf() >= p1.valueOf() && d.valueOf() <= p2.valueOf();
      };
    } catch (e) {
      console.error(e);
      return fallback;
    }
  } else if (/^>/.test(q)) {
    try {
      var p = dayjs(q.substring(1), format);
      return function (data) {
        var d = parseDate$1(data, format);
        return d.valueOf() > p.valueOf();
      };
    } catch (e) {
      console.error(e);
      return fallback;
    }
  } else if (/^</.test(q)) {
    try {
      var _p = dayjs(q.substring(1), format);

      return function (data) {
        var d = parseDate$1(data, format);
        return d.valueOf() < _p.valueOf();
      };
    } catch (e) {
      console.error(e);
      return fallback;
    }
  } else if (/^=/.test(q)) {
    q = q.substring(1);
  }

  try {
    var _p2 = dayjs(q, format);

    return function (data) {
      var d = parseDate$1(data, format);
      return exclude ? d.valueOf() !== _p2.valueOf() : d.valueOf() === _p2.valueOf();
    };
  } catch (e) {
    console.error(e);
    return fallback;
  }
}

function createDefaultQueryMatcher(query) {
  return function (data) {
    return data === query;
  };
}

var debounce = function debounce(fn, time) {
  var timeout;
  return function () {
    var _arguments = arguments,
        _this = this;

    var functionCall = function functionCall() {
      return fn.apply(_this, _arguments);
    };

    clearTimeout(timeout);
    timeout = setTimeout(functionCall, time);
  };
};

/**
 * A NodeIterator with iframes support and a method to check if an element is
 * matching a specified selector
 * @example
 * const iterator = new DOMIterator(
 *     document.querySelector("#context"), true
 * );
 * iterator.forEachNode(NodeFilter.SHOW_TEXT, node => {
 *     console.log(node);
 * }, node => {
 *     if(DOMIterator.matches(node.parentNode, ".ignore")){
 *         return NodeFilter.FILTER_REJECT;
 *     } else {
 *         return NodeFilter.FILTER_ACCEPT;
 *     }
 * }, () => {
 *     console.log("DONE");
 * });
 * @todo Outsource into separate repository
 */
var DOMIterator = /*#__PURE__*/function () {
  /**
   * @param {HTMLElement|HTMLElement[]|NodeList|string} ctx - The context DOM
   * element, an array of DOM elements, a NodeList or a selector
   * @param {boolean} [iframes=true] - A boolean indicating if iframes should
   * be handled
   * @param {string[]} [exclude=[]] - An array containing exclusion selectors
   * for iframes
   * @param {number} [iframesTimeout=5000] - A number indicating the ms to
   * wait before an iframe should be skipped, in case the load event isn't
   * fired. This also applies if the user is offline and the resource of the
   * iframe is online (either by the browsers "offline" mode or because
   * there's no internet connection)
   */
  function DOMIterator(ctx) {
    var iframes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var exclude = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var iframesTimeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 5000;

    _classCallCheck(this, DOMIterator);

    /**
     * The context of the instance. Either a DOM element, an array of DOM
     * elements, a NodeList or a selector
     * @type {HTMLElement|HTMLElement[]|NodeList|string}
     * @access protected
     */
    this.ctx = ctx;
    /**
     * Boolean indicating if iframe support is enabled
     * @type {boolean}
     * @access protected
     */

    this.iframes = iframes;
    /**
     * An array containing exclusion selectors for iframes
     * @type {string[]}
     */

    this.exclude = exclude;
    /**
     * The maximum ms to wait for a load event before skipping an iframe
     * @type {number}
     */

    this.iframesTimeout = iframesTimeout;
  }
  /**
   * Checks if the specified DOM element matches the selector
   * @param  {HTMLElement} element - The DOM element
   * @param  {string|string[]} selector - The selector or an array with
   * selectors
   * @return {boolean}
   * @access public
   */


  _createClass(DOMIterator, [{
    key: "getContexts",

    /**
     * Returns all contexts filtered by duplicates (even nested)
     * @return {HTMLElement[]} - An array containing DOM contexts
     * @access protected
     */
    value: function getContexts() {
      var ctx,
          filteredCtx = [];

      if (typeof this.ctx === 'undefined' || !this.ctx) {
        // e.g. null
        ctx = [];
      } else if (NodeList.prototype.isPrototypeOf(this.ctx)) {
        ctx = Array.prototype.slice.call(this.ctx);
      } else if (Array.isArray(this.ctx)) {
        ctx = this.ctx;
      } else if (typeof this.ctx === 'string') {
        ctx = Array.prototype.slice.call(document.querySelectorAll(this.ctx));
      } else {
        // e.g. HTMLElement or element inside iframe
        ctx = [this.ctx];
      } // filter duplicate text nodes


      ctx.forEach(function (ctx) {
        var isDescendant = filteredCtx.filter(function (contexts) {
          return contexts.contains(ctx);
        }).length > 0;

        if (filteredCtx.indexOf(ctx) === -1 && !isDescendant) {
          filteredCtx.push(ctx);
        }
      });
      return filteredCtx;
    }
    /**
     * @callback DOMIterator~getIframeContentsSuccessCallback
     * @param {HTMLDocument} contents - The contentDocument of the iframe
     */

    /**
     * Calls the success callback function with the iframe document. If it can't
     * be accessed it calls the error callback function
     * @param {HTMLElement} ifr - The iframe DOM element
     * @param {DOMIterator~getIframeContentsSuccessCallback} successFn
     * @param {function} [errorFn]
     * @access protected
     */

  }, {
    key: "getIframeContents",
    value: function getIframeContents(ifr, successFn) {
      var errorFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
      var doc;

      try {
        var ifrWin = ifr.contentWindow;
        doc = ifrWin.document;

        if (!ifrWin || !doc) {
          // no permission = null. Undefined in Phantom
          throw new Error('iframe inaccessible');
        }
      } catch (e) {
        errorFn();
      }

      if (doc) {
        successFn(doc);
      }
    }
    /**
     * Checks if an iframe is empty (if about:blank is the shown page)
     * @param {HTMLElement} ifr - The iframe DOM element
     * @return {boolean}
     * @access protected
     */

  }, {
    key: "isIframeBlank",
    value: function isIframeBlank(ifr) {
      var bl = 'about:blank',
          src = ifr.getAttribute('src').trim(),
          href = ifr.contentWindow.location.href;
      return href === bl && src !== bl && src;
    }
    /**
     * Observes the onload event of an iframe and calls the success callback or
     * the error callback if the iframe is inaccessible. If the event isn't
     * fired within the specified {@link DOMIterator#iframesTimeout}, then it'll
     * call the error callback too
     * @param {HTMLElement} ifr - The iframe DOM element
     * @param {DOMIterator~getIframeContentsSuccessCallback} successFn
     * @param {function} errorFn
     * @access protected
     */

  }, {
    key: "observeIframeLoad",
    value: function observeIframeLoad(ifr, successFn, errorFn) {
      var _this = this;

      var called = false,
          tout = null;

      var listener = function listener() {
        if (called) {
          return;
        }

        called = true;
        clearTimeout(tout);

        try {
          if (!_this.isIframeBlank(ifr)) {
            ifr.removeEventListener('load', listener);

            _this.getIframeContents(ifr, successFn, errorFn);
          }
        } catch (e) {
          // isIframeBlank maybe throws throws an error
          errorFn();
        }
      };

      ifr.addEventListener('load', listener);
      tout = setTimeout(listener, this.iframesTimeout);
    }
    /**
     * Callback when the iframe is ready
     * @callback DOMIterator~onIframeReadySuccessCallback
     * @param {HTMLDocument} contents - The contentDocument of the iframe
     */

    /**
     * Callback if the iframe can't be accessed
     * @callback DOMIterator~onIframeReadyErrorCallback
     */

    /**
     * Calls the callback if the specified iframe is ready for DOM access
     * @param  {HTMLElement} ifr - The iframe DOM element
     * @param  {DOMIterator~onIframeReadySuccessCallback} successFn - Success
     * callback
     * @param {DOMIterator~onIframeReadyErrorCallback} errorFn - Error callback
     * @see {@link http://stackoverflow.com/a/36155560/3894981} for
     * background information
     * @access protected
     */

  }, {
    key: "onIframeReady",
    value: function onIframeReady(ifr, successFn, errorFn) {
      try {
        if (ifr.contentWindow.document.readyState === 'complete') {
          if (this.isIframeBlank(ifr)) {
            this.observeIframeLoad(ifr, successFn, errorFn);
          } else {
            this.getIframeContents(ifr, successFn, errorFn);
          }
        } else {
          this.observeIframeLoad(ifr, successFn, errorFn);
        }
      } catch (e) {
        // accessing document failed
        errorFn();
      }
    }
    /**
     * Callback when all iframes are ready for DOM access
     * @callback DOMIterator~waitForIframesDoneCallback
     */

    /**
     * Iterates over all iframes and calls the done callback when all of them
     * are ready for DOM access (including nested ones)
     * @param {HTMLElement} ctx - The context DOM element
     * @param {DOMIterator~waitForIframesDoneCallback} done - Done callback
     */

  }, {
    key: "waitForIframes",
    value: function waitForIframes(ctx, done) {
      var _this2 = this;

      var eachCalled = 0;
      this.forEachIframe(ctx, function () {
        return true;
      }, function (ifr) {
        eachCalled++;

        _this2.waitForIframes(ifr.querySelector('html'), function () {
          if (! --eachCalled) {
            done();
          }
        });
      }, function (handled) {
        if (!handled) {
          done();
        }
      });
    }
    /**
     * Callback allowing to filter an iframe. Must return true when the element
     * should remain, otherwise false
     * @callback DOMIterator~forEachIframeFilterCallback
     * @param {HTMLElement} iframe - The iframe DOM element
     */

    /**
     * Callback for each iframe content
     * @callback DOMIterator~forEachIframeEachCallback
     * @param {HTMLElement} content - The iframe document
     */

    /**
     * Callback if all iframes inside the context were handled
     * @callback DOMIterator~forEachIframeEndCallback
     * @param {number} handled - The number of handled iframes (those who
     * wheren't filtered)
     */

    /**
     * Iterates over all iframes inside the specified context and calls the
     * callbacks when they're ready. Filters iframes based on the instance
     * exclusion selectors
     * @param {HTMLElement} ctx - The context DOM element
     * @param {DOMIterator~forEachIframeFilterCallback} filter - Filter callback
     * @param {DOMIterator~forEachIframeEachCallback} each - Each callback
     * @param {DOMIterator~forEachIframeEndCallback} [end] - End callback
     * @access protected
     */

  }, {
    key: "forEachIframe",
    value: function forEachIframe(ctx, filter, each) {
      var _this3 = this;

      var end = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
      var ifr = ctx.querySelectorAll('iframe'),
          open = ifr.length,
          handled = 0;
      ifr = Array.prototype.slice.call(ifr);

      var checkEnd = function checkEnd() {
        if (--open <= 0) {
          end(handled);
        }
      };

      if (!open) {
        checkEnd();
      }

      ifr.forEach(function (ifr) {
        if (DOMIterator.matches(ifr, _this3.exclude)) {
          checkEnd();
        } else {
          _this3.onIframeReady(ifr, function (con) {
            if (filter(ifr)) {
              handled++;
              each(con);
            }

            checkEnd();
          }, checkEnd);
        }
      });
    }
    /**
     * Creates a NodeIterator on the specified context
     * @see {@link https://developer.mozilla.org/en/docs/Web/API/NodeIterator}
     * @param {HTMLElement} ctx - The context DOM element
     * @param {DOMIterator~whatToShow} whatToShow
     * @param {DOMIterator~filterCb} filter
     * @return {NodeIterator}
     * @access protected
     */

  }, {
    key: "createIterator",
    value: function createIterator(ctx, whatToShow, filter) {
      return document.createNodeIterator(ctx, whatToShow, filter, false);
    }
    /**
     * Creates an instance of DOMIterator in an iframe
     * @param {HTMLDocument} contents - Iframe document
     * @return {DOMIterator}
     * @access protected
     */

  }, {
    key: "createInstanceOnIframe",
    value: function createInstanceOnIframe(contents) {
      return new DOMIterator(contents.querySelector('html'), this.iframes);
    }
    /**
     * Checks if an iframe occurs between two nodes, more specifically if an
     * iframe occurs before the specified node and after the specified prevNode
     * @param {HTMLElement} node - The node that should occur after the iframe
     * @param {HTMLElement} prevNode - The node that should occur before the
     * iframe
     * @param {HTMLElement} ifr - The iframe to check against
     * @return {boolean}
     * @access protected
     */

  }, {
    key: "compareNodeIframe",
    value: function compareNodeIframe(node, prevNode, ifr) {
      var compCurr = node.compareDocumentPosition(ifr),
          prev = Node.DOCUMENT_POSITION_PRECEDING;

      if (compCurr & prev) {
        if (prevNode !== null) {
          var compPrev = prevNode.compareDocumentPosition(ifr),
              after = Node.DOCUMENT_POSITION_FOLLOWING;

          if (compPrev & after) {
            return true;
          }
        } else {
          return true;
        }
      }

      return false;
    }
    /**
     * @typedef {DOMIterator~getIteratorNodeReturn}
     * @type {object.<string>}
     * @property {HTMLElement} prevNode - The previous node or null if there is
     * no
     * @property {HTMLElement} node - The current node
     */

    /**
     * Returns the previous and current node of the specified iterator
     * @param {NodeIterator} itr - The iterator
     * @return {DOMIterator~getIteratorNodeReturn}
     * @access protected
     */

  }, {
    key: "getIteratorNode",
    value: function getIteratorNode(itr) {
      var prevNode = itr.previousNode();
      var node;

      if (prevNode === null) {
        node = itr.nextNode();
      } else {
        node = itr.nextNode() && itr.nextNode();
      }

      return {
        prevNode: prevNode,
        node: node
      };
    }
    /**
     * An array containing objects. The object key "val" contains an iframe
     * DOM element. The object key "handled" contains a boolean indicating if
     * the iframe was handled already.
     * It wouldn't be enough to save all open or all already handled iframes.
     * The information of open iframes is necessary because they may occur after
     * all other text nodes (and compareNodeIframe would never be true). The
     * information of already handled iframes is necessary as otherwise they may
     * be handled multiple times
     * @typedef DOMIterator~checkIframeFilterIfr
     * @type {object[]}
     */

    /**
     * Checks if an iframe wasn't handled already and if so, calls
     * {@link DOMIterator#compareNodeIframe} to check if it should be handled.
     * Information wheter an iframe was or wasn't handled is given within the
     * <code>ifr</code> dictionary
     * @param {HTMLElement} node - The node that should occur after the iframe
     * @param {HTMLElement} prevNode - The node that should occur before the
     * iframe
     * @param {HTMLElement} currIfr - The iframe to check
     * @param {DOMIterator~checkIframeFilterIfr} ifr - The iframe dictionary.
     * Will be manipulated (by reference)
     * @return {boolean} Returns true when it should be handled, otherwise false
     * @access protected
     */

  }, {
    key: "checkIframeFilter",
    value: function checkIframeFilter(node, prevNode, currIfr, ifr) {
      var key = false,
          // false === doesn't exist
      handled = false;
      ifr.forEach(function (ifrDict, i) {
        if (ifrDict.val === currIfr) {
          key = i;
          handled = ifrDict.handled;
        }
      });

      if (this.compareNodeIframe(node, prevNode, currIfr)) {
        if (key === false && !handled) {
          ifr.push({
            val: currIfr,
            handled: true
          });
        } else if (key !== false && !handled) {
          ifr[key].handled = true;
        }

        return true;
      }

      if (key === false) {
        ifr.push({
          val: currIfr,
          handled: false
        });
      }

      return false;
    }
    /**
     * Creates an iterator on all open iframes in the specified array and calls
     * the end callback when finished
     * @param {DOMIterator~checkIframeFilterIfr} ifr
     * @param {DOMIterator~whatToShow} whatToShow
     * @param  {DOMIterator~forEachNodeCallback} eCb - Each callback
     * @param {DOMIterator~filterCb} fCb
     * @access protected
     */

  }, {
    key: "handleOpenIframes",
    value: function handleOpenIframes(ifr, whatToShow, eCb, fCb) {
      var _this4 = this;

      ifr.forEach(function (ifrDict) {
        if (!ifrDict.handled) {
          _this4.getIframeContents(ifrDict.val, function (con) {
            _this4.createInstanceOnIframe(con).forEachNode(whatToShow, eCb, fCb);
          });
        }
      });
    }
    /**
     * Iterates through all nodes in the specified context and handles iframe
     * nodes at the correct position
     * @param {DOMIterator~whatToShow} whatToShow
     * @param {HTMLElement} ctx - The context
     * @param  {DOMIterator~forEachNodeCallback} eachCb - Each callback
     * @param {DOMIterator~filterCb} filterCb - Filter callback
     * @param {DOMIterator~forEachNodeEndCallback} doneCb - End callback
     * @access protected
     */

  }, {
    key: "iterateThroughNodes",
    value: function iterateThroughNodes(whatToShow, ctx, eachCb, filterCb, doneCb) {
      var _this5 = this;

      var itr = this.createIterator(ctx, whatToShow, filterCb);

      var ifr = [],
          elements = [],
          node,
          prevNode,
          retrieveNodes = function retrieveNodes() {
        var _this5$getIteratorNod = _this5.getIteratorNode(itr);

        prevNode = _this5$getIteratorNod.prevNode;
        node = _this5$getIteratorNod.node;
        return node;
      };

      while (retrieveNodes()) {
        if (this.iframes) {
          this.forEachIframe(ctx, function (currIfr) {
            // note that ifr will be manipulated here
            return _this5.checkIframeFilter(node, prevNode, currIfr, ifr);
          }, function (con) {
            _this5.createInstanceOnIframe(con).forEachNode(whatToShow, function (ifrNode) {
              return elements.push(ifrNode);
            }, filterCb);
          });
        } // it's faster to call the each callback in an array loop
        // than in this while loop


        elements.push(node);
      }

      elements.forEach(function (node) {
        eachCb(node);
      });

      if (this.iframes) {
        this.handleOpenIframes(ifr, whatToShow, eachCb, filterCb);
      }

      doneCb();
    }
    /**
     * Callback for each node
     * @callback DOMIterator~forEachNodeCallback
     * @param {HTMLElement} node - The DOM text node element
     */

    /**
     * Callback if all contexts were handled
     * @callback DOMIterator~forEachNodeEndCallback
     */

    /**
     * Iterates over all contexts and initializes
     * {@link DOMIterator#iterateThroughNodes iterateThroughNodes} on them
     * @param {DOMIterator~whatToShow} whatToShow
     * @param  {DOMIterator~forEachNodeCallback} each - Each callback
     * @param {DOMIterator~filterCb} filter - Filter callback
     * @param {DOMIterator~forEachNodeEndCallback} done - End callback
     * @access public
     */

  }, {
    key: "forEachNode",
    value: function forEachNode(whatToShow, each, filter) {
      var _this6 = this;

      var done = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
      var contexts = this.getContexts();
      var open = contexts.length;

      if (!open) {
        done();
      }

      contexts.forEach(function (ctx) {
        var ready = function ready() {
          _this6.iterateThroughNodes(whatToShow, ctx, each, filter, function () {
            if (--open <= 0) {
              // call end all contexts were handled
              done();
            }
          });
        }; // wait for iframes to avoid recursive calls, otherwise this would
        // perhaps reach the recursive function call limit with many nodes


        if (_this6.iframes) {
          _this6.waitForIframes(ctx, ready);
        } else {
          ready();
        }
      });
    }
    /**
     * Callback to filter nodes. Can return e.g. NodeFilter.FILTER_ACCEPT or
     * NodeFilter.FILTER_REJECT
     * @see {@link http://tinyurl.com/zdczmm2}
     * @callback DOMIterator~filterCb
     * @param {HTMLElement} node - The node to filter
     */

    /**
     * @typedef DOMIterator~whatToShow
     * @see {@link http://tinyurl.com/zfqqkx2}
     * @type {number}
     */

  }], [{
    key: "matches",
    value: function matches(element, selector) {
      var selectors = typeof selector === 'string' ? [selector] : selector,
          fn = element.matches || element.matchesSelector || element.msMatchesSelector || element.mozMatchesSelector || element.oMatchesSelector || element.webkitMatchesSelector;

      if (fn) {
        var match = false;
        selectors.every(function (sel) {
          if (fn.call(element, sel)) {
            match = true;
            return false;
          }

          return true;
        });
        return match;
      } else {
        // may be false e.g. when el is a textNode
        return false;
      }
    }
  }]);

  return DOMIterator;
}();

/**
 * Marks search terms in DOM elements
 * @example
 * new Mark(document.querySelector(".context")).mark("lorem ipsum");
 * @example
 * new Mark(document.querySelector(".context")).markRegExp(/lorem/gmi);
 */

var Mark = /*#__PURE__*/function () {
  // eslint-disable-line no-unused-vars

  /**
   * @param {HTMLElement|HTMLElement[]|NodeList|string} ctx - The context DOM
   * element, an array of DOM elements, a NodeList or a selector
   */
  function Mark(ctx) {
    _classCallCheck(this, Mark);

    /**
     * The context of the instance. Either a DOM element, an array of DOM
     * elements, a NodeList or a selector
     * @type {HTMLElement|HTMLElement[]|NodeList|string}
     * @access protected
     */
    this.ctx = ctx;
    /**
     * Specifies if the current browser is a IE (necessary for the node
     * normalization bug workaround). See {@link Mark#unwrapMatches}
     * @type {boolean}
     * @access protected
     */

    this.ie = false;
    var ua = window.navigator.userAgent;

    if (ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1) {
      this.ie = true;
    }
  }
  /**
   * Options defined by the user. They will be initialized from one of the
   * public methods. See {@link Mark#mark}, {@link Mark#markRegExp},
   * {@link Mark#markRanges} and {@link Mark#unmark} for option properties.
   * @type {object}
   * @param {object} [val] - An object that will be merged with defaults
   * @access protected
   */


  _createClass(Mark, [{
    key: "log",

    /**
     * Logs a message if log is enabled
     * @param {string} msg - The message to log
     * @param {string} [level="debug"] - The log level, e.g. <code>warn</code>
     * <code>error</code>, <code>debug</code>
     * @access protected
     */
    value: function log(msg) {
      var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'debug';
      var log = this.opt.log;

      if (!this.opt.debug) {
        return;
      }

      if (_typeof(log) === 'object' && typeof log[level] === 'function') {
        log[level]("mark.js: ".concat(msg));
      }
    }
    /**
     * Escapes a string for usage within a regular expression
     * @param {string} str - The string to escape
     * @return {string}
     * @access protected
     */

  }, {
    key: "escapeStr",
    value: function escapeStr(str) {
      // eslint-disable-next-line no-useless-escape
      return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
    }
    /**
     * Creates a regular expression string to match the specified search
     * term including synonyms, diacritics and accuracy if defined
     * @param  {string} str - The search term to be used
     * @return {string}
     * @access protected
     */

  }, {
    key: "createRegExp",
    value: function createRegExp(str) {
      if (this.opt.wildcards !== 'disabled') {
        str = this.setupWildcardsRegExp(str);
      }

      str = this.escapeStr(str);

      if (Object.keys(this.opt.synonyms).length) {
        str = this.createSynonymsRegExp(str);
      }

      if (this.opt.ignoreJoiners || this.opt.ignorePunctuation.length) {
        str = this.setupIgnoreJoinersRegExp(str);
      }

      if (this.opt.diacritics) {
        str = this.createDiacriticsRegExp(str);
      }

      str = this.createMergedBlanksRegExp(str);

      if (this.opt.ignoreJoiners || this.opt.ignorePunctuation.length) {
        str = this.createJoinersRegExp(str);
      }

      if (this.opt.wildcards !== 'disabled') {
        str = this.createWildcardsRegExp(str);
      }

      str = this.createAccuracyRegExp(str);
      return str;
    }
    /**
     * Creates a regular expression string to match the defined synonyms
     * @param  {string} str - The search term to be used
     * @return {string}
     * @access protected
     */

  }, {
    key: "createSynonymsRegExp",
    value: function createSynonymsRegExp(str) {
      var syn = this.opt.synonyms,
          sens = this.opt.caseSensitive ? '' : 'i',
          // add replacement character placeholder before and after the
      // synonym group
      joinerPlaceholder = this.opt.ignoreJoiners || this.opt.ignorePunctuation.length ? "\0" : '';

      for (var index in syn) {
        if (syn.hasOwnProperty(index)) {
          var value = syn[index],
              k1 = this.opt.wildcards !== 'disabled' ? this.setupWildcardsRegExp(index) : this.escapeStr(index),
              k2 = this.opt.wildcards !== 'disabled' ? this.setupWildcardsRegExp(value) : this.escapeStr(value);

          if (k1 !== '' && k2 !== '') {
            str = str.replace(new RegExp("(".concat(this.escapeStr(k1), "|").concat(this.escapeStr(k2), ")"), "gm".concat(sens)), joinerPlaceholder + "(".concat(this.processSynomyms(k1), "|") + "".concat(this.processSynomyms(k2), ")") + joinerPlaceholder);
          }
        }
      }

      return str;
    }
    /**
     * Setup synonyms to work with ignoreJoiners and or ignorePunctuation
     * @param {string} str - synonym key or value to process
     * @return {string} - processed synonym string
     */

  }, {
    key: "processSynomyms",
    value: function processSynomyms(str) {
      if (this.opt.ignoreJoiners || this.opt.ignorePunctuation.length) {
        str = this.setupIgnoreJoinersRegExp(str);
      }

      return str;
    }
    /**
     * Sets up the regular expression string to allow later insertion of
     * wildcard regular expression matches
     * @param  {string} str - The search term to be used
     * @return {string}
     * @access protected
     */

  }, {
    key: "setupWildcardsRegExp",
    value: function setupWildcardsRegExp(str) {
      // replace single character wildcard with unicode 0001
      str = str.replace(/(?:\\)*\?/g, function (val) {
        return val.charAt(0) === '\\' ? '?' : "\x01";
      }); // replace multiple character wildcard with unicode 0002

      return str.replace(/(?:\\)*\*/g, function (val) {
        return val.charAt(0) === '\\' ? '*' : "\x02";
      });
    }
    /**
     * Sets up the regular expression string to allow later insertion of
     * wildcard regular expression matches
     * @param  {string} str - The search term to be used
     * @return {string}
     * @access protected
     */

  }, {
    key: "createWildcardsRegExp",
    value: function createWildcardsRegExp(str) {
      // default to "enable" (i.e. to not include spaces)
      // "withSpaces" uses `[\\S\\s]` instead of `.` because the latter
      // does not match new line characters
      var spaces = this.opt.wildcards === 'withSpaces';
      return str // replace unicode 0001 with a RegExp class to match any single
      // character, or any single non-whitespace character depending
      // on the setting
      .replace(/\u0001/g, spaces ? '[\\S\\s]?' : '\\S?') // replace unicode 0002 with a RegExp class to match zero or
      // more characters, or zero or more non-whitespace characters
      // depending on the setting
      .replace(/\u0002/g, spaces ? '[\\S\\s]*?' : '\\S*');
    }
    /**
     * Sets up the regular expression string to allow later insertion of
     * designated characters (soft hyphens & zero width characters)
     * @param  {string} str - The search term to be used
     * @return {string}
     * @access protected
     */

  }, {
    key: "setupIgnoreJoinersRegExp",
    value: function setupIgnoreJoinersRegExp(str) {
      // adding a "null" unicode character as it will not be modified by the
      // other "create" regular expression functions
      return str.replace(/[^(|)\\]/g, function (val, indx, original) {
        // don't add a null after an opening "(", around a "|" or before
        // a closing "(", or between an escapement (e.g. \+)
        var nextChar = original.charAt(indx + 1);

        if (/[(|)\\]/.test(nextChar) || nextChar === '') {
          return val;
        } else {
          return val + "\0";
        }
      });
    }
    /**
     * Creates a regular expression string to allow ignoring of designated
     * characters (soft hyphens, zero width characters & punctuation) based on
     * the specified option values of <code>ignorePunctuation</code> and
     * <code>ignoreJoiners</code>
     * @param  {string} str - The search term to be used
     * @return {string}
     * @access protected
     */

  }, {
    key: "createJoinersRegExp",
    value: function createJoinersRegExp(str) {
      var joiner = [];
      var ignorePunctuation = this.opt.ignorePunctuation;

      if (Array.isArray(ignorePunctuation) && ignorePunctuation.length) {
        joiner.push(this.escapeStr(ignorePunctuation.join('')));
      }

      if (this.opt.ignoreJoiners) {
        // u+00ad = soft hyphen
        // u+200b = zero-width space
        // u+200c = zero-width non-joiner
        // u+200d = zero-width joiner
        joiner.push("\\u00ad\\u200b\\u200c\\u200d");
      }

      return joiner.length ? str.split(/\u0000+/).join("[".concat(joiner.join(''), "]*")) : str;
    }
    /**
     * Creates a regular expression string to match diacritics
     * @param  {string} str - The search term to be used
     * @return {string}
     * @access protected
     */

  }, {
    key: "createDiacriticsRegExp",
    value: function createDiacriticsRegExp(str) {
      var sens = this.opt.caseSensitive ? '' : 'i',
          dct = this.opt.caseSensitive ? ['aàáảãạăằắẳẵặâầấẩẫậäåāą', 'AÀÁẢÃẠĂẰẮẲẴẶÂẦẤẨẪẬÄÅĀĄ', 'cçćč', 'CÇĆČ', 'dđď', 'DĐĎ', 'eèéẻẽẹêềếểễệëěēę', 'EÈÉẺẼẸÊỀẾỂỄỆËĚĒĘ', 'iìíỉĩịîïī', 'IÌÍỈĨỊÎÏĪ', 'lł', 'LŁ', 'nñňń', 'NÑŇŃ', 'oòóỏõọôồốổỗộơởỡớờợöøō', 'OÒÓỎÕỌÔỒỐỔỖỘƠỞỠỚỜỢÖØŌ', 'rř', 'RŘ', 'sšśșş', 'SŠŚȘŞ', 'tťțţ', 'TŤȚŢ', 'uùúủũụưừứửữựûüůū', 'UÙÚỦŨỤƯỪỨỬỮỰÛÜŮŪ', 'yýỳỷỹỵÿ', 'YÝỲỶỸỴŸ', 'zžżź', 'ZŽŻŹ'] : ['aàáảãạăằắẳẵặâầấẩẫậäåāąAÀÁẢÃẠĂẰẮẲẴẶÂẦẤẨẪẬÄÅĀĄ', 'cçćčCÇĆČ', 'dđďDĐĎ', 'eèéẻẽẹêềếểễệëěēęEÈÉẺẼẸÊỀẾỂỄỆËĚĒĘ', 'iìíỉĩịîïīIÌÍỈĨỊÎÏĪ', 'lłLŁ', 'nñňńNÑŇŃ', 'oòóỏõọôồốổỗộơởỡớờợöøōOÒÓỎÕỌÔỒỐỔỖỘƠỞỠỚỜỢÖØŌ', 'rřRŘ', 'sšśșşSŠŚȘŞ', 'tťțţTŤȚŢ', 'uùúủũụưừứửữựûüůūUÙÚỦŨỤƯỪỨỬỮỰÛÜŮŪ', 'yýỳỷỹỵÿYÝỲỶỸỴŸ', 'zžżźZŽŻŹ'];
      var handled = [];
      str.split('').forEach(function (ch) {
        dct.every(function (dct) {
          // Check if the character is inside a diacritics list
          if (dct.indexOf(ch) !== -1) {
            // Check if the related diacritics list was not
            // handled yet
            if (handled.indexOf(dct) > -1) {
              return false;
            } // Make sure that the character OR any other
            // character in the diacritics list will be matched


            str = str.replace(new RegExp("[".concat(dct, "]"), "gm".concat(sens)), "[".concat(dct, "]"));
            handled.push(dct);
          }

          return true;
        });
      });
      return str;
    }
    /**
     * Creates a regular expression string that merges whitespace characters
     * including subsequent ones into a single pattern, one or multiple
     * whitespaces
     * @param  {string} str - The search term to be used
     * @return {string}
     * @access protected
     */

  }, {
    key: "createMergedBlanksRegExp",
    value: function createMergedBlanksRegExp(str) {
      return str.replace(/[\s]+/gmi, '[\\s]+');
    }
    /**
     * Creates a regular expression string to match the specified string with
     * the defined accuracy. As in the regular expression of "exactly" can be
     * a group containing a blank at the beginning, all regular expressions will
     * be created with two groups. The first group can be ignored (may contain
     * the said blank), the second contains the actual match
     * @param  {string} str - The searm term to be used
     * @return {str}
     * @access protected
     */

  }, {
    key: "createAccuracyRegExp",
    value: function createAccuracyRegExp(str) {
      var _this = this;

      var chars = '!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~¡¿';
      var acc = this.opt.accuracy,
          val = typeof acc === 'string' ? acc : acc.value,
          ls = typeof acc === 'string' ? [] : acc.limiters,
          lsJoin = '';
      ls.forEach(function (limiter) {
        lsJoin += "|".concat(_this.escapeStr(limiter));
      });

      switch (val) {
        case 'partially':
        default:
          return "()(".concat(str, ")");

        case 'complementary':
          lsJoin = '\\s' + (lsJoin ? lsJoin : this.escapeStr(chars));
          return "()([^".concat(lsJoin, "]*").concat(str, "[^").concat(lsJoin, "]*)");

        case 'exactly':
          return "(^|\\s".concat(lsJoin, ")(").concat(str, ")(?=$|\\s").concat(lsJoin, ")");
      }
    }
    /**
     * @typedef Mark~separatedKeywords
     * @type {object.<string>}
     * @property {array.<string>} keywords - The list of keywords
     * @property {number} length - The length
     */

    /**
     * Returns a list of keywords dependent on whether separate word search
     * was defined. Also it filters empty keywords
     * @param {array} sv - The array of keywords
     * @return {Mark~separatedKeywords}
     * @access protected
     */

  }, {
    key: "getSeparatedKeywords",
    value: function getSeparatedKeywords(sv) {
      var _this2 = this;

      var stack = [];
      sv.forEach(function (kw) {
        if (!_this2.opt.separateWordSearch) {
          if (kw.trim() && stack.indexOf(kw) === -1) {
            stack.push(kw);
          }
        } else {
          kw.split(' ').forEach(function (kwSplitted) {
            if (kwSplitted.trim() && stack.indexOf(kwSplitted) === -1) {
              stack.push(kwSplitted);
            }
          });
        }
      });
      return {
        // sort because of https://git.io/v6USg
        'keywords': stack.sort(function (a, b) {
          return b.length - a.length;
        }),
        'length': stack.length
      };
    }
    /**
     * Check if a value is a number
     * @param {number|string} value - the value to check;
     * numeric strings allowed
     * @return {boolean}
     * @access protected
     */

  }, {
    key: "isNumeric",
    value: function isNumeric(value) {
      // http://stackoverflow.com/a/16655847/145346
      // eslint-disable-next-line eqeqeq
      return Number(parseFloat(value)) == value;
    }
    /**
     * @typedef Mark~rangeObject
     * @type {object}
     * @property {number} start - The start position within the composite value
     * @property {number} length - The length of the string to mark within the
     * composite value.
     */

    /**
     * @typedef Mark~setOfRanges
     * @type {object[]}
     * @property {Mark~rangeObject}
     */

    /**
     * Returns a processed list of integer offset indexes that do not overlap
     * each other, and remove any string values or additional elements
     * @param {Mark~setOfRanges} array - unprocessed raw array
     * @return {Mark~setOfRanges} - processed array with any invalid entries
     * removed
     * @throws Will throw an error if an array of objects is not passed
     * @access protected
     */

  }, {
    key: "checkRanges",
    value: function checkRanges(array) {
      var _this3 = this;

      // start and length indexes are included in an array of objects
      // [{start: 0, length: 1}, {start: 4, length: 5}]
      // quick validity check of the first entry only
      if (!Array.isArray(array) || Object.prototype.toString.call(array[0]) !== '[object Object]') {
        this.log('markRanges() will only accept an array of objects');
        this.opt.noMatch(array);
        return [];
      }

      var stack = [];
      var last = 0;
      array // acending sort to ensure there is no overlap in start & end
      // offsets
      .sort(function (a, b) {
        return a.start - b.start;
      }).forEach(function (item) {
        var _this3$callNoMatchOnI = _this3.callNoMatchOnInvalidRanges(item, last),
            start = _this3$callNoMatchOnI.start,
            end = _this3$callNoMatchOnI.end,
            valid = _this3$callNoMatchOnI.valid;

        if (valid) {
          // preserve item in case there are extra key:values within
          item.start = start;
          item.length = end - start;
          stack.push(item);
          last = end;
        }
      });
      return stack;
    }
    /**
     * @typedef Mark~validObject
     * @type {object}
     * @property {number} start - The start position within the composite value
     * @property {number} end - The calculated end position within the composite
     * value.
     * @property {boolean} valid - boolean value indicating that the start and
     * calculated end range is valid
     */

    /**
      * Initial validation of ranges for markRanges. Preliminary checks are done
      * to ensure the start and length values exist and are not zero or non-
      * numeric
      * @param {Mark~rangeObject} range - the current range object
      * @param {number} last - last index of range
      * @return {Mark~validObject}
      * @access protected
      */

  }, {
    key: "callNoMatchOnInvalidRanges",
    value: function callNoMatchOnInvalidRanges(range, last) {
      var start,
          end,
          valid = false;

      if (range && typeof range.start !== 'undefined') {
        start = parseInt(range.start, 10);
        end = start + parseInt(range.length, 10); // ignore overlapping values & non-numeric entries

        if (this.isNumeric(range.start) && this.isNumeric(range.length) && end - last > 0 && end - start > 0) {
          valid = true;
        } else {
          this.log('Ignoring invalid or overlapping range: ' + "".concat(JSON.stringify(range)));
          this.opt.noMatch(range);
        }
      } else {
        this.log("Ignoring invalid range: ".concat(JSON.stringify(range)));
        this.opt.noMatch(range);
      }

      return {
        start: start,
        end: end,
        valid: valid
      };
    }
    /**
     * Check valid range for markRanges. Check ranges with access to the context
     * string. Range values are double checked, lengths that extend the mark
     * beyond the string length are limitied and ranges containing only
     * whitespace are ignored
     * @param {Mark~rangeObject} range - the current range object
     * @param {number} originalLength - original length of the context string
     * @param {string} string - current content string
     * @return {Mark~validObject}
     * @access protected
     */

  }, {
    key: "checkWhitespaceRanges",
    value: function checkWhitespaceRanges(range, originalLength, string) {
      var end,
          valid = true,
          // the max value changes after the DOM is manipulated
      max = string.length,
          // adjust offset to account for wrapped text node
      offset = originalLength - max,
          start = parseInt(range.start, 10) - offset; // make sure to stop at max

      start = start > max ? max : start;
      end = start + parseInt(range.length, 10);

      if (end > max) {
        end = max;
        this.log("End range automatically set to the max value of ".concat(max));
      }

      if (start < 0 || end - start < 0 || start > max || end > max) {
        valid = false;
        this.log("Invalid range: ".concat(JSON.stringify(range)));
        this.opt.noMatch(range);
      } else if (string.substring(start, end).replace(/\s+/g, '') === '') {
        valid = false; // whitespace only; even if wrapped it is not visible

        this.log('Skipping whitespace only range: ' + JSON.stringify(range));
        this.opt.noMatch(range);
      }

      return {
        start: start,
        end: end,
        valid: valid
      };
    }
    /**
     * @typedef Mark~getTextNodesDict
     * @type {object.<string>}
     * @property {string} value - The composite value of all text nodes
     * @property {object[]} nodes - An array of objects
     * @property {number} nodes.start - The start position within the composite
     * value
     * @property {number} nodes.end - The end position within the composite
     * value
     * @property {HTMLElement} nodes.node - The DOM text node element
     */

    /**
     * Callback
     * @callback Mark~getTextNodesCallback
     * @param {Mark~getTextNodesDict}
     */

    /**
     * Calls the callback with an object containing all text nodes (including
     * iframe text nodes) with start and end positions and the composite value
     * of them (string)
     * @param {Mark~getTextNodesCallback} cb - Callback
     * @access protected
     */

  }, {
    key: "getTextNodes",
    value: function getTextNodes(cb) {
      var _this4 = this;

      var val = '',
          nodes = [];
      this.iterator.forEachNode(NodeFilter.SHOW_TEXT, function (node) {
        nodes.push({
          start: val.length,
          end: (val += node.textContent).length,
          node: node
        });
      }, function (node) {
        if (_this4.matchesExclude(node.parentNode)) {
          return NodeFilter.FILTER_REJECT;
        } else {
          return NodeFilter.FILTER_ACCEPT;
        }
      }, function () {
        cb({
          value: val,
          nodes: nodes
        });
      });
    }
    /**
     * Checks if an element matches any of the specified exclude selectors. Also
     * it checks for elements in which no marks should be performed (e.g.
     * script and style tags) and optionally already marked elements
     * @param  {HTMLElement} el - The element to check
     * @return {boolean}
     * @access protected
     */

  }, {
    key: "matchesExclude",
    value: function matchesExclude(el) {
      return DOMIterator.matches(el, this.opt.exclude.concat([// ignores the elements itself, not their childrens (selector *)
      'script', 'style', 'title', 'head', 'html']));
    }
    /**
     * Wraps the instance element and class around matches that fit the start
     * and end positions within the node
     * @param  {HTMLElement} node - The DOM text node
     * @param  {number} start - The position where to start wrapping
     * @param  {number} end - The position where to end wrapping
     * @return {HTMLElement} Returns the splitted text node that will appear
     * after the wrapped text node
     * @access protected
     */

  }, {
    key: "wrapRangeInTextNode",
    value: function wrapRangeInTextNode(node, start, end) {
      var hEl = !this.opt.element ? 'mark' : this.opt.element,
          startNode = node.splitText(start),
          ret = startNode.splitText(end - start);
      var repl = document.createElement(hEl);
      repl.setAttribute('data-markjs', 'true');

      if (this.opt.className) {
        repl.setAttribute('class', this.opt.className);
      }

      repl.textContent = startNode.textContent;
      startNode.parentNode.replaceChild(repl, startNode);
      return ret;
    }
    /**
     * @typedef Mark~wrapRangeInMappedTextNodeDict
     * @type {object.<string>}
     * @property {string} value - The composite value of all text nodes
     * @property {object[]} nodes - An array of objects
     * @property {number} nodes.start - The start position within the composite
     * value
     * @property {number} nodes.end - The end position within the composite
     * value
     * @property {HTMLElement} nodes.node - The DOM text node element
     */

    /**
     * Each callback
     * @callback Mark~wrapMatchesEachCallback
     * @param {HTMLElement} node - The wrapped DOM element
     * @param {number} lastIndex - The last matching position within the
     * composite value of text nodes
     */

    /**
     * Filter callback
     * @callback Mark~wrapMatchesFilterCallback
     * @param {HTMLElement} node - The matching text node DOM element
     */

    /**
     * Determines matches by start and end positions using the text node
     * dictionary even across text nodes and calls
     * {@link Mark#wrapRangeInTextNode} to wrap them
     * @param  {Mark~wrapRangeInMappedTextNodeDict} dict - The dictionary
     * @param  {number} start - The start position of the match
     * @param  {number} end - The end position of the match
     * @param  {Mark~wrapMatchesFilterCallback} filterCb - Filter callback
     * @param  {Mark~wrapMatchesEachCallback} eachCb - Each callback
     * @access protected
     */

  }, {
    key: "wrapRangeInMappedTextNode",
    value: function wrapRangeInMappedTextNode(dict, start, end, filterCb, eachCb) {
      var _this5 = this;

      // iterate over all text nodes to find the one matching the positions
      dict.nodes.every(function (n, i) {
        var sibl = dict.nodes[i + 1];

        if (typeof sibl === 'undefined' || sibl.start > start) {
          if (!filterCb(n.node)) {
            return false;
          } // map range from dict.value to text node


          var s = start - n.start,
              e = (end > n.end ? n.end : end) - n.start,
              startStr = dict.value.substr(0, n.start),
              endStr = dict.value.substr(e + n.start);
          n.node = _this5.wrapRangeInTextNode(n.node, s, e); // recalculate positions to also find subsequent matches in the
          // same text node. Necessary as the text node in dict now only
          // contains the splitted part after the wrapped one

          dict.value = startStr + endStr;
          dict.nodes.forEach(function (k, j) {
            if (j >= i) {
              if (dict.nodes[j].start > 0 && j !== i) {
                dict.nodes[j].start -= e;
              }

              dict.nodes[j].end -= e;
            }
          });
          end -= e;
          eachCb(n.node.previousSibling, n.start);

          if (end > n.end) {
            start = n.end;
          } else {
            return false;
          }
        }

        return true;
      });
    }
    /**
     * Filter callback before each wrapping
     * @callback Mark~wrapMatchesFilterCallback
     * @param {string} match - The matching string
     * @param {HTMLElement} node - The text node where the match occurs
     */

    /**
     * Callback for each wrapped element
     * @callback Mark~wrapMatchesEachCallback
     * @param {HTMLElement} element - The marked DOM element
     */

    /**
     * Callback on end
     * @callback Mark~wrapMatchesEndCallback
     */

    /**
     * Wraps the instance element and class around matches within single HTML
     * elements in all contexts
     * @param {RegExp} regex - The regular expression to be searched for
     * @param {number} ignoreGroups - A number indicating the amount of RegExp
     * matching groups to ignore
     * @param {Mark~wrapMatchesFilterCallback} filterCb
     * @param {Mark~wrapMatchesEachCallback} eachCb
     * @param {Mark~wrapMatchesEndCallback} endCb
     * @access protected
     */

  }, {
    key: "wrapMatches",
    value: function wrapMatches(regex, ignoreGroups, filterCb, eachCb, endCb) {
      var _this6 = this;

      var matchIdx = ignoreGroups === 0 ? 0 : ignoreGroups + 1;
      this.getTextNodes(function (dict) {
        dict.nodes.forEach(function (node) {
          node = node.node;
          var match;

          while ((match = regex.exec(node.textContent)) !== null && match[matchIdx] !== '') {
            if (!filterCb(match[matchIdx], node)) {
              continue;
            }

            var pos = match.index;

            if (matchIdx !== 0) {
              for (var i = 1; i < matchIdx; i++) {
                pos += match[i].length;
              }
            }

            node = _this6.wrapRangeInTextNode(node, pos, pos + match[matchIdx].length);
            eachCb(node.previousSibling); // reset index of last match as the node changed and the
            // index isn't valid anymore http://tinyurl.com/htsudjd

            regex.lastIndex = 0;
          }
        });
        endCb();
      });
    }
    /**
     * Callback for each wrapped element
     * @callback Mark~wrapMatchesAcrossElementsEachCallback
     * @param {HTMLElement} element - The marked DOM element
     */

    /**
     * Filter callback before each wrapping
     * @callback Mark~wrapMatchesAcrossElementsFilterCallback
     * @param {string} match - The matching string
     * @param {HTMLElement} node - The text node where the match occurs
     */

    /**
     * Callback on end
     * @callback Mark~wrapMatchesAcrossElementsEndCallback
     */

    /**
     * Wraps the instance element and class around matches across all HTML
     * elements in all contexts
     * @param {RegExp} regex - The regular expression to be searched for
     * @param {number} ignoreGroups - A number indicating the amount of RegExp
     * matching groups to ignore
     * @param {Mark~wrapMatchesAcrossElementsFilterCallback} filterCb
     * @param {Mark~wrapMatchesAcrossElementsEachCallback} eachCb
     * @param {Mark~wrapMatchesAcrossElementsEndCallback} endCb
     * @access protected
     */

  }, {
    key: "wrapMatchesAcrossElements",
    value: function wrapMatchesAcrossElements(regex, ignoreGroups, filterCb, eachCb, endCb) {
      var _this7 = this;

      var matchIdx = ignoreGroups === 0 ? 0 : ignoreGroups + 1;
      this.getTextNodes(function (dict) {
        var match;

        while ((match = regex.exec(dict.value)) !== null && match[matchIdx] !== '') {
          // calculate range inside dict.value
          var start = match.index;

          if (matchIdx !== 0) {
            for (var i = 1; i < matchIdx; i++) {
              start += match[i].length;
            }
          }

          var end = start + match[matchIdx].length; // note that dict will be updated automatically, as it'll change
          // in the wrapping process, due to the fact that text
          // nodes will be splitted

          _this7.wrapRangeInMappedTextNode(dict, start, end, function (node) {
            return filterCb(match[matchIdx], node);
          }, function (node, lastIndex) {
            regex.lastIndex = lastIndex;
            eachCb(node);
          });
        }

        endCb();
      });
    }
    /**
     * Callback for each wrapped element
     * @callback Mark~wrapRangeFromIndexEachCallback
     * @param {HTMLElement} element - The marked DOM element
     * @param {Mark~rangeObject} range - the current range object; provided
     * start and length values will be numeric integers modified from the
     * provided original ranges.
     */

    /**
     * Filter callback before each wrapping
     * @callback Mark~wrapRangeFromIndexFilterCallback
     * @param {HTMLElement} node - The text node which includes the range
     * @param {Mark~rangeObject} range - the current range object
     * @param {string} match - string extracted from the matching range
     * @param {number} counter - A counter indicating the number of all marks
     */

    /**
     * Callback on end
     * @callback Mark~wrapRangeFromIndexEndCallback
     */

    /**
     * Wraps the indicated ranges across all HTML elements in all contexts
     * @param {Mark~setOfRanges} ranges
     * @param {Mark~wrapRangeFromIndexFilterCallback} filterCb
     * @param {Mark~wrapRangeFromIndexEachCallback} eachCb
     * @param {Mark~wrapRangeFromIndexEndCallback} endCb
     * @access protected
     */

  }, {
    key: "wrapRangeFromIndex",
    value: function wrapRangeFromIndex(ranges, filterCb, eachCb, endCb) {
      var _this8 = this;

      this.getTextNodes(function (dict) {
        var originalLength = dict.value.length;
        ranges.forEach(function (range, counter) {
          var _this8$checkWhitespac = _this8.checkWhitespaceRanges(range, originalLength, dict.value),
              start = _this8$checkWhitespac.start,
              end = _this8$checkWhitespac.end,
              valid = _this8$checkWhitespac.valid;

          if (valid) {
            _this8.wrapRangeInMappedTextNode(dict, start, end, function (node) {
              return filterCb(node, range, dict.value.substring(start, end), counter);
            }, function (node) {
              eachCb(node, range);
            });
          }
        });
        endCb();
      });
    }
    /**
     * Unwraps the specified DOM node with its content (text nodes or HTML)
     * without destroying possibly present events (using innerHTML) and
     * normalizes the parent at the end (merge splitted text nodes)
     * @param  {HTMLElement} node - The DOM node to unwrap
     * @access protected
     */

  }, {
    key: "unwrapMatches",
    value: function unwrapMatches(node) {
      var parent = node.parentNode;
      var docFrag = document.createDocumentFragment();

      while (node.firstChild) {
        docFrag.appendChild(node.removeChild(node.firstChild));
      }

      parent.replaceChild(docFrag, node);

      if (!this.ie) {
        // use browser's normalize method
        parent.normalize();
      } else {
        // custom method (needs more time)
        this.normalizeTextNode(parent);
      }
    }
    /**
     * Normalizes text nodes. It's a workaround for the native normalize method
     * that has a bug in IE (see attached link). Should only be used in IE
     * browsers as it's slower than the native method.
     * @see {@link http://tinyurl.com/z5asa8c}
     * @param {HTMLElement} node - The DOM node to normalize
     * @access protected
     */

  }, {
    key: "normalizeTextNode",
    value: function normalizeTextNode(node) {
      if (!node) {
        return;
      }

      if (node.nodeType === 3) {
        while (node.nextSibling && node.nextSibling.nodeType === 3) {
          node.nodeValue += node.nextSibling.nodeValue;
          node.parentNode.removeChild(node.nextSibling);
        }
      } else {
        this.normalizeTextNode(node.firstChild);
      }

      this.normalizeTextNode(node.nextSibling);
    }
    /**
     * Callback when finished
     * @callback Mark~commonDoneCallback
     * @param {number} totalMatches - The number of marked elements
     */

    /**
     * @typedef Mark~commonOptions
     * @type {object.<string>}
     * @property {string} [element="mark"] - HTML element tag name
     * @property {string} [className] - An optional class name
     * @property {string[]} [exclude] - An array with exclusion selectors.
     * Elements matching those selectors will be ignored
     * @property {boolean} [iframes=false] - Whether to search inside iframes
     * @property {Mark~commonDoneCallback} [done]
     * @property {boolean} [debug=false] - Wheter to log messages
     * @property {object} [log=window.console] - Where to log messages (only if
     * debug is true)
     */

    /**
     * Callback for each marked element
     * @callback Mark~markRegExpEachCallback
     * @param {HTMLElement} element - The marked DOM element
     */

    /**
     * Callback if there were no matches
     * @callback Mark~markRegExpNoMatchCallback
     * @param {RegExp} regexp - The regular expression
     */

    /**
     * Callback to filter matches
     * @callback Mark~markRegExpFilterCallback
     * @param {HTMLElement} textNode - The text node which includes the match
     * @param {string} match - The matching string for the RegExp
     * @param {number} counter - A counter indicating the number of all marks
     */

    /**
     * These options also include the common options from
     * {@link Mark~commonOptions}
     * @typedef Mark~markRegExpOptions
     * @type {object.<string>}
     * @property {Mark~markRegExpEachCallback} [each]
     * @property {Mark~markRegExpNoMatchCallback} [noMatch]
     * @property {Mark~markRegExpFilterCallback} [filter]
     */

    /**
     * Marks a custom regular expression
     * @param  {RegExp} regexp - The regular expression
     * @param  {Mark~markRegExpOptions} [opt] - Optional options object
     * @access public
     */

  }, {
    key: "markRegExp",
    value: function markRegExp(regexp, opt) {
      var _this9 = this;

      this.opt = opt;
      this.log("Searching with expression \"".concat(regexp, "\""));
      var totalMatches = 0,
          fn = 'wrapMatches';

      var eachCb = function eachCb(element) {
        totalMatches++;

        _this9.opt.each(element);
      };

      if (this.opt.acrossElements) {
        fn = 'wrapMatchesAcrossElements';
      }

      this[fn](regexp, this.opt.ignoreGroups, function (match, node) {
        return _this9.opt.filter(node, match, totalMatches);
      }, eachCb, function () {
        if (totalMatches === 0) {
          _this9.opt.noMatch(regexp);
        }

        _this9.opt.done(totalMatches);
      });
    }
    /**
     * Callback for each marked element
     * @callback Mark~markEachCallback
     * @param {HTMLElement} element - The marked DOM element
     */

    /**
     * Callback if there were no matches
     * @callback Mark~markNoMatchCallback
     * @param {RegExp} term - The search term that was not found
     */

    /**
     * Callback to filter matches
     * @callback Mark~markFilterCallback
     * @param {HTMLElement} textNode - The text node which includes the match
     * @param {string} match - The matching term
     * @param {number} totalCounter - A counter indicating the number of all
     * marks
     * @param {number} termCounter - A counter indicating the number of marks
     * for the specific match
     */

    /**
     * @typedef Mark~markAccuracyObject
     * @type {object.<string>}
     * @property {string} value - A accuracy string value
     * @property {string[]} limiters - A custom array of limiters. For example
     * <code>["-", ","]</code>
     */

    /**
     * @typedef Mark~markAccuracySetting
     * @type {string}
     * @property {"partially"|"complementary"|"exactly"|Mark~markAccuracyObject}
     * [accuracy="partially"] - Either one of the following string values:
     * <ul>
     *   <li><i>partially</i>: When searching for "lor" only "lor" inside
     *   "lorem" will be marked</li>
     *   <li><i>complementary</i>: When searching for "lor" the whole word
     *   "lorem" will be marked</li>
     *   <li><i>exactly</i>: When searching for "lor" only those exact words
     *   will be marked. In this example nothing inside "lorem". This value
     *   is equivalent to the previous option <i>wordBoundary</i></li>
     * </ul>
     * Or an object containing two properties:
     * <ul>
     *   <li><i>value</i>: One of the above named string values</li>
     *   <li><i>limiters</i>: A custom array of string limiters for accuracy
     *   "exactly" or "complementary"</li>
     * </ul>
     */

    /**
     * @typedef Mark~markWildcardsSetting
     * @type {string}
     * @property {"disabled"|"enabled"|"withSpaces"}
     * [wildcards="disabled"] - Set to any of the following string values:
     * <ul>
     *   <li><i>disabled</i>: Disable wildcard usage</li>
     *   <li><i>enabled</i>: When searching for "lor?m", the "?" will match zero
     *   or one non-space character (e.g. "lorm", "loram", "lor3m", etc). When
     *   searching for "lor*m", the "*" will match zero or more non-space
     *   characters (e.g. "lorm", "loram", "lor123m", etc).</li>
     *   <li><i>withSpaces</i>: When searching for "lor?m", the "?" will
     *   match zero or one space or non-space character (e.g. "lor m", "loram",
     *   etc). When searching for "lor*m", the "*" will match zero or more space
     *   or non-space characters (e.g. "lorm", "lore et dolor ipsum", "lor: m",
     *   etc).</li>
     * </ul>
     */

    /**
     * @typedef Mark~markIgnorePunctuationSetting
     * @type {string[]}
     * @property {string} The strings in this setting will contain punctuation
     * marks that will be ignored:
     * <ul>
     *   <li>These punctuation marks can be between any characters, e.g. setting
     *   this option to <code>["'"]</code> would match "Worlds", "World's" and
     *   "Wo'rlds"</li>
     *   <li>One or more apostrophes between the letters would still produce a
     *   match (e.g. "W'o''r'l'd's").</li>
     *   <li>A typical setting for this option could be as follows:
     *   <pre>ignorePunctuation: ":;.,-–—‒_(){}[]!'\"+=".split(""),</pre> This
     *   setting includes common punctuation as well as a minus, en-dash,
     *   em-dash and figure-dash
     *   ({@link https://en.wikipedia.org/wiki/Dash#Figure_dash ref}), as well
     *   as an underscore.</li>
     * </ul>
     */

    /**
     * These options also include the common options from
     * {@link Mark~commonOptions}
     * @typedef Mark~markOptions
     * @type {object.<string>}
     * @property {boolean} [separateWordSearch=true] - Whether to search for
     * each word separated by a blank instead of the complete term
     * @property {boolean} [diacritics=true] - If diacritic characters should be
     * matched. ({@link https://en.wikipedia.org/wiki/Diacritic Diacritics})
     * @property {object} [synonyms] - An object with synonyms. The key will be
     * a synonym for the value and the value for the key
     * @property {Mark~markAccuracySetting} [accuracy]
     * @property {Mark~markWildcardsSetting} [wildcards]
     * @property {boolean} [acrossElements=false] - Whether to find matches
     * across HTML elements. By default, only matches within single HTML
     * elements will be found
     * @property {boolean} [ignoreJoiners=false] - Whether to ignore word
     * joiners inside of key words. These include soft-hyphens, zero-width
     * space, zero-width non-joiners and zero-width joiners.
     * @property {Mark~markIgnorePunctuationSetting} [ignorePunctuation]
     * @property {Mark~markEachCallback} [each]
     * @property {Mark~markNoMatchCallback} [noMatch]
     * @property {Mark~markFilterCallback} [filter]
     */

    /**
     * Marks the specified search terms
     * @param {string|string[]} [sv] - Search value, either a search string or
     * an array containing multiple search strings
     * @param  {Mark~markOptions} [opt] - Optional options object
     * @access public
     */

  }, {
    key: "mark",
    value: function mark(sv, opt) {
      var _this10 = this;

      this.opt = opt;
      var totalMatches = 0,
          fn = 'wrapMatches';

      var _this$getSeparatedKey = this.getSeparatedKeywords(typeof sv === 'string' ? [sv] : sv),
          kwArr = _this$getSeparatedKey.keywords,
          kwArrLen = _this$getSeparatedKey.length,
          sens = this.opt.caseSensitive ? '' : 'i',
          handler = function handler(kw) {
        // async function calls as iframes are async too
        var regex = new RegExp(_this10.createRegExp(kw), "gm".concat(sens)),
            matches = 0;

        _this10.log("Searching with expression \"".concat(regex, "\""));

        _this10[fn](regex, 1, function (term, node) {
          return _this10.opt.filter(node, kw, totalMatches, matches);
        }, function (element) {
          matches++;
          totalMatches++;

          _this10.opt.each(element);
        }, function () {
          if (matches === 0) {
            _this10.opt.noMatch(kw);
          }

          if (kwArr[kwArrLen - 1] === kw) {
            _this10.opt.done(totalMatches);
          } else {
            handler(kwArr[kwArr.indexOf(kw) + 1]);
          }
        });
      };

      if (this.opt.acrossElements) {
        fn = 'wrapMatchesAcrossElements';
      }

      if (kwArrLen === 0) {
        this.opt.done(totalMatches);
      } else {
        handler(kwArr[0]);
      }
    }
    /**
     * Callback for each marked element
     * @callback Mark~markRangesEachCallback
     * @param {HTMLElement} element - The marked DOM element
     * @param {array} range - array of range start and end points
     */

    /**
     * Callback if a processed range is invalid, out-of-bounds, overlaps another
     * range, or only matches whitespace
     * @callback Mark~markRangesNoMatchCallback
     * @param {Mark~rangeObject} range - a range object
     */

    /**
     * Callback to filter matches
     * @callback Mark~markRangesFilterCallback
     * @param {HTMLElement} node - The text node which includes the range
     * @param {array} range - array of range start and end points
     * @param {string} match - string extracted from the matching range
     * @param {number} counter - A counter indicating the number of all marks
     */

    /**
     * These options also include the common options from
     * {@link Mark~commonOptions}
     * @typedef Mark~markRangesOptions
     * @type {object.<string>}
     * @property {Mark~markRangesEachCallback} [each]
     * @property {Mark~markRangesNoMatchCallback} [noMatch]
     * @property {Mark~markRangesFilterCallback} [filter]
     */

    /**
     * Marks an array of objects containing a start with an end or length of the
     * string to mark
     * @param  {Mark~setOfRanges} rawRanges - The original (preprocessed)
     * array of objects
     * @param  {Mark~markRangesOptions} [opt] - Optional options object
     * @access public
     */

  }, {
    key: "markRanges",
    value: function markRanges(rawRanges, opt) {
      var _this11 = this;

      this.opt = opt;
      var totalMatches = 0,
          ranges = this.checkRanges(rawRanges);

      if (ranges && ranges.length) {
        this.log('Starting to mark with the following ranges: ' + JSON.stringify(ranges));
        this.wrapRangeFromIndex(ranges, function (node, range, match, counter) {
          return _this11.opt.filter(node, range, match, counter);
        }, function (element, range) {
          totalMatches++;

          _this11.opt.each(element, range);
        }, function () {
          _this11.opt.done(totalMatches);
        });
      } else {
        this.opt.done(totalMatches);
      }
    }
    /**
     * Removes all marked elements inside the context with their HTML and
     * normalizes the parent at the end
     * @param  {Mark~commonOptions} [opt] - Optional options object
     * @access public
     */

  }, {
    key: "unmark",
    value: function unmark(opt) {
      var _this12 = this;

      this.opt = opt;
      var sel = this.opt.element ? this.opt.element : '*';
      sel += '[data-markjs]';

      if (this.opt.className) {
        sel += ".".concat(this.opt.className);
      }

      this.log("Removal selector \"".concat(sel, "\""));
      this.iterator.forEachNode(NodeFilter.SHOW_ELEMENT, function (node) {
        _this12.unwrapMatches(node);
      }, function (node) {
        var matchesSel = DOMIterator.matches(node, sel),
            matchesExclude = _this12.matchesExclude(node);

        if (!matchesSel || matchesExclude) {
          return NodeFilter.FILTER_REJECT;
        } else {
          return NodeFilter.FILTER_ACCEPT;
        }
      }, this.opt.done);
    }
  }, {
    key: "opt",
    set: function set(val) {
      this._opt = Object.assign({}, {
        'element': '',
        'className': '',
        'exclude': [],
        'iframes': false,
        'iframesTimeout': 5000,
        'separateWordSearch': true,
        'diacritics': true,
        'synonyms': {},
        'accuracy': 'partially',
        'acrossElements': false,
        'caseSensitive': false,
        'ignoreJoiners': false,
        'ignoreGroups': 0,
        'ignorePunctuation': [],
        'wildcards': 'disabled',
        'each': function each() {},
        'noMatch': function noMatch() {},
        'filter': function filter() {
          return true;
        },
        'done': function done() {},
        'debug': false,
        'log': window.console
      }, val);
    },
    get: function get() {
      return this._opt;
    }
    /**
     * An instance of DOMIterator
     * @type {DOMIterator}
     * @access protected
     */

  }, {
    key: "iterator",
    get: function get() {
      // always return new instance in case there were option changes
      return new DOMIterator(this.ctx, this.opt.iframes, this.opt.exclude, this.opt.iframesTimeout);
    }
  }]);

  return Mark;
}();

function Mark$1(ctx) {
  var _this = this;

  var instance = new Mark(ctx);

  this.mark = function (sv, opt) {
    instance.mark(sv, opt);
    return _this;
  };

  this.markRegExp = function (sv, opt) {
    instance.markRegExp(sv, opt);
    return _this;
  };

  this.markRanges = function (sv, opt) {
    instance.markRanges(sv, opt);
    return _this;
  };

  this.unmark = function (opt) {
    instance.unmark(opt);
    return _this;
  };

  return this;
}

function highlightRows(tableContext, element, store) {
  if (store.state.fullTextSearch && store.state.fullTextSearchHighlight && store.state.filteredTotalCount > -1) {
    if (store.state.fullTextSearch && store.state.fullTextQuery && store.state.fullTextQuery !== '') {
      Object.keys(store.state.filteredCache).forEach(function (k) {
        var row = store.state.filteredCache[k].row;
        highlight(row, store.state.fullTextQuery);
      });
    }
  }

  if (store.state.columnSearch && store.state.columnSearchHighlight && store.state.filteredTotalCount > -1) {
    Object.keys(store.state.filteredCache).forEach(function (k) {
      var row = store.state.filteredCache[k].row;
      Object.keys(store.state.searchColumns).forEach(function (c) {
        var data = store.state.searchColumns[c];
        var col = Array.from(row.children).find(function (x) {
          return x.getAttribute('data-prop') === c;
        });
        highlight(col, data.query);
      });
    });
  }
}

function highlight(element, query) {
  var ins = new Mark$1(element);
  ins.unmark();
  ins.mark(query, {
    className: 'highlight'
  });
}

function unhighlightRows(store) {
  if (store.state.filteredTotalCount > -1 && store.state.filteredCache && (store.state.columnSearchHighlight || store.state.fullTextSearchHighlight)) {
    Object.keys(store.state.filteredCache).forEach(function (k) {
      var row = store.state.filteredCache[k].row;
      var ins = new Mark$1(row);
      ins.unmark();
    });
  }
}

function getOnColumnSearchInput(tableContext) {
  var store = tableContext.store;
  return function (h, e) {
    unhighlightRows(store);
    store.state.focusElement = e.target.getAttribute('id');
    var v = e.target.value;

    if (v != null && v !== '') {
      if (store.state.searchColumns == null) {
        store.state.searchColumns = {};
      }

      store.state.searchColumns[h] = {
        query: v,
        matcher: null
      };

      if (store.state.debounceTime > -1) {
        store.state.searchColumns[h].matcher = createMatcher(store, store.state.schema.properties[h], store.state.searchColumns[h].query);
        store.state.columnSearchDebounced();
      }
    } else if (v == null || v === '') {
      if (store.state.searchColumns != null && store.state.searchColumns[h]) {
        delete store.state.searchColumns[h];
      }

      if (store.state.debounceTime > -1) {
        store.state.columnSearchDebounced();
      }
    }
  };
}
function getOnColumnSearchKeydown(tableContext) {
  var store = tableContext.store;
  return function (h, e) {
    unhighlightRows(store);
    store.state.focusElement = e.target.getAttribute('id');

    if (store.state.debounceTime === -1 && (e.which || e.keyCode) && (e.which === 13 || e.keyCode === 13)) {
      if (store.state.searchColumns && store.state.searchColumns[h]) {
        store.state.searchColumns[h].matcher = createMatcher(store, store.state.schema.properties[h], store.state.searchColumns[h].query);
      }

      store.state.columnSearchDebounced();
    }
  };
}

function filter(store) {
  if (store.state.searchColumns == null || Object.keys(store.state.searchColumns).length === 0) {
    store.setState(store.getResetState());
  } else {
    var _columnSearchInCache = columnSearchInCache(store.state.searchColumns, store.state.cache),
        filteredCache = _columnSearchInCache.filteredCache,
        filteredTotalCount = _columnSearchInCache.filteredTotalCount;

    store.setState(_objectSpread2({}, store.getResetState(), {
      focusElement: store.state.focusElement,
      searchColumns: store.state.searchColumns,
      filteredCache: filteredCache,
      filteredTotalCount: filteredTotalCount
    }));
  }
}

function createColumnSearchDebounce(tableContext) {
  tableContext.store.state.columnSearchDebounced = debounce(function () {
    if (Object.keys(tableContext.store.state.cache).length === tableContext.store.state.firstTotalCount && tableContext.store.state.totalCount > 0 && tableContext.store.state.totalCount <= tableContext.store.state.firstTotalCount) {
      filter(tableContext.store);
    } else {
      loadDataForSearch(tableContext);
    }
  }, tableContext.store.state.debounceTime === -1 ? 0 : tableContext.store.state.debounceTime);
}
var SearchBuilder = /*#__PURE__*/function () {
  function SearchBuilder(cache) {
    _classCallCheck(this, SearchBuilder);

    this.cache = cache;
    this.runCache = {};
    this.criteria = [];
  }

  _createClass(SearchBuilder, [{
    key: "addCriteria",
    value: function addCriteria(key, matcher) {
      var _this = this;

      if (this.criteria.length === 0) {
        Object.keys(this.cache).forEach(function (k) {
          var entry = _objectSpread2({}, _this.cache[k], {
            cacheIndex: k
          }); // save the cache index for later retrieval


          if (matcher(entry.data[key])) {
            _this.runCache[k] = entry;
          }
        });
      } else {
        Object.keys(this.runCache).forEach(function (k) {
          var entry = _objectSpread2({}, _this.runCache[k]);

          if (!matcher(entry.data[key])) {
            delete _this.runCache[k];
          }
        });
      }

      this.criteria.push({
        key: key,
        matcher: matcher
      });
      return this;
    }
  }, {
    key: "search",
    value: function search() {
      var _this2 = this;

      var filteredCache = {};
      var run = 0;
      Object.keys(this.runCache).forEach(function (k) {
        var entry = _objectSpread2({}, _this2.runCache[k]);

        filteredCache[run] = entry;
        run++;
      });
      return {
        filteredCache: filteredCache,
        filteredTotalCount: Object.keys(filteredCache).length
      };
    }
  }]);

  return SearchBuilder;
}();
function mapExternalSearchColumns(searchColumns) {
  if (!searchColumns) return;
  var sc = {};
  Object.keys(searchColumns).forEach(function (s) {
    sc[s] = searchColumns[s].query;
  });
  return sc;
}

function getRange(store) {
  var start = store.state.pageIndex === 0 ? 0 : store.state.pageIndex * store.state.pageSize;
  var limit = store.state.pageSize;
  var end = start + limit;

  if (store.state.filteredTotalCount > -1 && store.state.filteredTotalCount <= store.state.pageSize) {
    limit = store.state.filteredTotalCount;

    if (end > store.state.filteredTotalCount) {
      end = store.state.filteredTotalCount;
    }
  } else if (store.state.filteredTotalCount > -1 && end > store.state.filteredTotalCount) {
    end = store.state.filteredTotalCount;
  } else if (store.state.totalCount !== 0 && store.state.totalCount <= store.state.pageSize) {
    limit = store.state.totalCount;

    if (end > store.state.totalCount) {
      end = store.state.totalCount;
    }
  } else if (store.state.totalCount !== 0 && end > store.state.totalCount) {
    limit = store.state.totalCount;
    end = store.state.totalCount;
  }

  return {
    start: start,
    end: end,
    limit: limit
  };
}

function createRow(tableContext, data, id, index) {
  if (!id) {
    id = generateId();
  }

  var row = null;

  if (hasChildRow(tableContext.store.state)) {
    row = ChildTableRow(tableContext, data, id, index, false);
  } else {
    row = BodyRow(tableContext, data, id);
  }

  return {
    id: id,
    data: data,
    row: row,
    created: Date.now()
  };
}

function loadData(tableContext) {
  var emitPageChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var _getRange = getRange(tableContext.store),
      start = _getRange.start,
      limit = _getRange.limit; // check if data has already loaded for the current pageIndex


  if (hasRows(tableContext.store)) {
    if (emitPageChange && tableContext.store.state.onPageChange && typeof tableContext.store.state.onPageChange === 'function') {
      tableContext.store.state.onPageChange(tableContext.table, start, limit);
    }

    return;
  }

  var dataArgs = [start, limit, tableContext.store.state.sortHeader, tableContext.store.state.sortDirection, tableContext.store.state.fullTextQuery, mapExternalSearchColumns(tableContext.store.state.searchColumns)];
  var dataObj = tableContext.store.state.data.apply(null, dataArgs);

  if ((_typeof(dataObj) === 'object' || typeof dataObj === 'function') && typeof dataObj.then === 'function') {
    dataObj.then(function (data) {
      return cacheData(tableContext, start, limit, data, emitPageChange);
    });
  } else {
    cacheData(tableContext, start, limit, dataObj, emitPageChange);
  }
}
function loadChildTable(tableContext, index, element) {
  var args = [index, tableContext.store.state.cache[index].data, element];
  var ct = tableContext.store.state.childTable.apply(null, args);

  if (ct) {
    removeClasses(['text-center', 'is-loading'], element);
  }
}
function cacheData(tableContext, start, limit, obj, emitPageChange) {
  if (!isValidData(obj)) {
    throw new Error('Invalid data!');
  }

  var arr = obj;
  var totalCount = tableContext.store.state.totalCount;

  if (isObject$1(obj)) {
    totalCount = obj.totalCount;
    arr = obj.data;
  }

  if (tableContext.store.state.firstTotalCount === -1) {
    tableContext.store.state.firstTotalCount = totalCount;
  }

  var cd = {};
  var run = start;

  for (var i = 0; i < arr.length; i++) {
    var data = arr[i];
    var row = createRow(tableContext, data, null, run);
    cd[run] = row;
    ++run;
  }

  var cache = _objectSpread2({}, tableContext.store.state.cache, {}, cd);

  tableContext.store.setState({
    totalCount: totalCount,
    cache: cache
  }, true, function () {
    if (emitPageChange && tableContext.store.state.onPageChange && typeof tableContext.store.state.onPageChange === 'function') {
      tableContext.store.state.onPageChange(tableContext.table, start, limit);
    }

    if (tableContext.store.state.onAfterDataLoad && typeof tableContext.store.state.onAfterDataLoad === 'function') {
      tableContext.store.state.onAfterDataLoad(tableContext.table, start, limit);
    }
  });
}
function setRowData(tableContext, index, data) {
  var notify = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var cd = {};

  if (tableContext.store.state.filteredTotalCount > -1) {
    var cacheIndex = tableContext.store.state.filteredCache[index].cacheIndex;
    var ci = tableContext.store.state.cache[cacheIndex];
    cd = _objectSpread2({}, ci, {}, createRow(tableContext, data, ci.id, cacheIndex));

    var cache = _objectSpread2({}, tableContext.store.state.cache);

    var filteredCache = _objectSpread2({}, tableContext.store.state.filteredCache);

    cache[cacheIndex] = cd;
    filteredCache[index] = cd;
    tableContext.store.setState({
      cache: cache,
      filteredCache: filteredCache
    }, notify);
  } else {
    var _ci = tableContext.store.state.cache[index];
    cd = _objectSpread2({}, _ci, {}, createRow(tableContext, data, _ci.id, index));

    var _cache = _objectSpread2({}, tableContext.store.state.cache);

    _cache[index] = cd;
    tableContext.store.setState({
      cache: _cache
    }, notify);
  }
}
function getRowData(tableContext, index) {
  if (tableContext.store.state.filteredTotalCount > -1) {
    var cacheIndex = tableContext.store.state.filteredCache[index].cacheIndex;
    return tableContext.store.state.cache[cacheIndex].row;
  } else {
    return tableContext.store.state.cache[index].row;
  }
}
function addRow(tableContext, data) {
  var cd = {};
  var index = Object.keys(tableContext.store.state.cache).length;
  cd[index] = createRow(tableContext, data, null, index);

  var cache = _objectSpread2({}, tableContext.store.state.cache, {}, cd);

  var totalCount = tableContext.store.state.totalCount + 1;
  tableContext.store.setState({
    cache: cache,
    totalCount: totalCount
  });
}
function removeData(store, indexStr) {
  var index = parseInt(indexStr, 10);
  var cacheIndex = index;
  var eCache = store.state.cache;

  if (store.state.filteredTotalCount > -1) {
    cacheIndex = store.state.filteredCache[index].cacheIndex;
  } // rebuild indexes


  var cache = {};
  var start = cacheIndex + 1;
  var run = cacheIndex;

  if (cacheIndex > 0) {
    for (var i = 0; i < cacheIndex; i++) {
      cache[i] = eCache[i];
    }
  }

  for (var _i = start; _i < Object.keys(eCache).length; _i++) {
    cache[run] = eCache[_i];
    ++run;
  }

  var totalCount = store.state.totalCount - 1; // re-run search on the new cache data

  if (store.state.filteredTotalCount > -1) {
    var query = store.state.fullTextQuery;

    if (query == null || query === '') {
      var _columnSearchInCache = columnSearchInCache(store.state.searchColumns, cache),
          filteredCache = _columnSearchInCache.filteredCache,
          filteredTotalCount = _columnSearchInCache.filteredTotalCount;

      store.setState({
        cache: cache,
        totalCount: totalCount,
        filteredCache: filteredCache,
        filteredTotalCount: filteredTotalCount
      });
    } else {
      var searchMatcher = parseQuery(store, query);

      var _fullTextSearchInCach = fullTextSearchInCache(searchMatcher, cache),
          _filteredCache = _fullTextSearchInCach.filteredCache,
          _filteredTotalCount = _fullTextSearchInCach.filteredTotalCount;

      store.setState({
        cache: cache,
        totalCount: totalCount,
        filteredCache: _filteredCache,
        filteredTotalCount: _filteredTotalCount
      });
    }
  } else {
    store.setState({
      cache: cache,
      totalCount: totalCount
    });
  }
}

function cleanCache(store) {
  if (store.state.ttl > -1) {
    var kte = [];
    var keys = Object.keys(store.state.cache);
    keys.forEach(function (k) {
      if (Date.now() - store.state.cache[k].created > store.state.ttl) {
        kte.push(k);
      }
    });

    if (kte.length > 0) {
      kte.forEach(function (k) {
        return delete store.state.cache[k];
      });
    }
  }
}

function hasRows(store) {
  cleanCache(store);

  var _getRange2 = getRange(store),
      start = _getRange2.start,
      end = _getRange2.end;

  var rc = end - start;
  var r = 0;

  for (var i = start; i < end; i++) {
    if (store.state.filteredTotalCount > -1 && store.state.filteredCache[i] && store.state.filteredCache[i].data && store.state.filteredCache[i].row) {
      ++r;
    } else if (store.state.cache[i] && store.state.cache[i].data && store.state.cache[i].row) {
      ++r;
    }
  }

  return r > 0 && rc === r;
}
function getRows(store) {
  var r = [];

  var _getRange3 = getRange(store),
      start = _getRange3.start,
      end = _getRange3.end;

  for (var i = start; i < end; i++) {
    r.push(store.state.filteredTotalCount > -1 ? store.state.filteredCache[i].row : store.state.cache[i].row);
  }

  return r;
}

function dynamicSort(property, prop, locale) {
  var sortOrder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  return function (a, b) {
    if (sortOrder === -1) {
      if (prop.format && /date-?/.test(prop.format)) {
        return new Date(b.data[property]) - new Date(a.data[property]);
      }

      if (prop.type === 'number') {
        return b.data[property] - a.data[property];
      }

      if (a.data[property] == null || b.data[property] == null) {
        handleNullValue(a, b, property);
      }

      return b.data[property].toString().localeCompare(a.data[property].toString(), locale, {
        ignorePunctuation: true
      });
    } else {
      if (prop.format && /date-?/.test(prop.format)) {
        return new Date(a.data[property]) - new Date(b.data[property]);
      }

      if (prop.type === 'number') {
        return a.data[property] - b.data[property];
      }

      if (a.data[property] == null || b.data[property] == null) {
        handleNullValue(a, b, property);
      }

      return a.data[property].toString().localeCompare(b.data[property].toString(), locale, {
        ignorePunctuation: true
      });
    }
  };
}

function handleNullValue(a, b, property) {
  if (a.data[property] == null) {
    return a.data[property] = '';
  }

  if (b.data[property] == null) {
    return b.data[property] = '';
  }
}

function sortData(tableContext) {
  var store = tableContext.store;

  if (Object.keys(store.state.cache).length === store.state.totalCount) {
    var s = {};
    var k = 'cache';

    if (store.state.filteredTotalCount > -1) {
      k = 'filteredCache';
      s = Object.values(store.state.filteredCache);
    } else {
      s = Object.values(store.state.cache);
    }

    s.sort(dynamicSort(store.state.sortHeader, store.state.schema.properties[store.state.sortHeader], store.state.locale, store.state.sortDirection === 'desc' ? -1 : 1));
    var cache = {};

    for (var i = 0; i < s.length; i++) {
      cache[i] = s[i];
    }

    var newState = {};
    newState[k] = cache;
    store.setState(newState);
  } else {
    store.setState({
      cache: {},
      totalCount: store.state.totalCount,
      pageIndex: 0
    }, false);
    loadData(tableContext);
  }
}
function enableRowActions(store, index, enable) {
  var selectors = ['button', 'select', 'input[type=checkbox]'];
  selectors.forEach(function (s) {
    var row = store.state.cache[index].row;
    var elements = [];

    if (Array.isArray(row)) {
      row[0].classList[enable ? 'remove' : 'add']('disabled');
      elements = row[0].querySelectorAll(s);
    } else {
      row.classList[enable ? 'remove' : 'add']('disabled');
      elements = row.querySelectorAll(s);
    }

    for (var i = 0; i < elements.length; ++i) {
      if (elements[i].hasAttribute('aria-expanded')) continue;

      if (enable) {
        elements[i].removeAttribute('disabled');
      } else {
        elements[i].setAttribute('disabled', 'disabled');
      }
    }
  });
}
function loadDataForSearch(tableContext) {
  var store = tableContext.store;
  var searchColumns = store.state.searchColumns;

  if (searchColumns && Object.keys(searchColumns).length === 0) {
    searchColumns = null;
  }

  store.setState({
    cache: {},
    totalCount: 0,
    pageIndex: 0,
    firstVisiblePageIndex: 0,
    searchColumns: searchColumns,
    displayedEntriesRendered: false,
    paginationRendered: false
  }, false);
  loadData(tableContext);
}
function columnSearchInCache(searchColumns, cache) {
  var sb = new SearchBuilder(cache);
  Object.keys(searchColumns).forEach(function (sck) {
    sb = sb.addCriteria(sck, searchColumns[sck].matcher);
  });
  return sb.search();
}
function fullTextSearchInCache(searchMatcher, cache) {
  var filteredCache = {};
  var run = 0;
  Object.keys(cache).forEach(function (k) {
    var entry = _objectSpread2({}, cache[k], {
      cacheIndex: k
    }); // save the cache index for later retrieval


    if (searchMatcher(entry.data)) {
      filteredCache[run] = entry;
      run++;
    }
  });
  return {
    filteredCache: filteredCache,
    filteredTotalCount: Object.keys(filteredCache).length
  };
}
function selectAllRows(tableContext, key, toSelect) {
  var store = tableContext.store;
  var r = [];

  var _getRange4 = getRange(store),
      start = _getRange4.start,
      end = _getRange4.end;

  for (var i = start; i < end; i++) {
    r.push(store.state.filteredTotalCount > -1 ? {
      index: i,
      data: store.state.filteredCache[i]
    } : {
      index: i,
      data: store.state.cache[i]
    });
  }

  var keys = Object.keys(store.state.schema.properties);
  var idx = keys.indexOf(key);

  if (idx > -1) {
    var data = [];
    r.forEach(function (d) {
      var rows = d.data.row;
      var row = null;

      if (Array.isArray(rows)) {
        row = rows[0];
      } else {
        row = rows;
      }

      var col = row.querySelector("[data-prop=\"".concat(key, "\"]"));

      if (col) {
        var cb = col.querySelector('input[type="checkbox"]');

        if (cb) {
          if (cb.disabled) return;
          cb.checked = toSelect;
          data.push({
            index: d.index,
            rowData: d.data.data,
            value: toSelect
          });
        }
      }
    });
    var onAction = tableContext.store.state.onAction;

    if (onAction) {
      onAction(tableContext.table, key, data);
    }
  }
}
function toggleColumn(element, store, column) {
  var hcell = element.querySelector("thead th[data-prop=\"".concat(column, "\"]"));

  if (hcell) {
    hcell.classList.toggle('d-none');
  }

  Object.keys(store.state.cache).forEach(function (k) {
    var entry = store.state.cache[k];
    var selector = "[data-prop=\"".concat(column, "\"]");
    var row = entry.row;
    var cell = null;

    if (Array.isArray(row)) {
      cell = row[0].querySelector(selector);
    } else {
      cell = row.querySelector(selector);
    }

    if (cell) {
      cell.classList.toggle('d-none');
    }
  });
}

function elementEmpty(el) {
  while (el.firstChild) {
    el.removeChild(el.firstChild);
  }
}

function getOnSelectAllCheckboxes(tableContext) {
  return function (e, k) {
    selectAllRows(tableContext, k, e.target.checked);
  };
}
function deselectSelectAllCheckbox(tableContext) {
  var schemaProps = tableContext.store.state.schema.properties;
  var schemaPropKeys = Object.keys(schemaProps);
  schemaPropKeys.filter(function (key) {
    return !isSchema(key, schemaProps[key]);
  }).forEach(function (key) {
    var isBoolean = schemaProps && schemaProps[key] && schemaProps[key].type === 'boolean';
    var hasCheckbox = isBoolean && schemaProps[key].format === 'checkbox' && schemaProps[key].editable;
    var headerCell = tableContext.element.querySelector("thead th[data-prop=\"".concat(key, "\"]"));

    if (hasCheckbox && headerCell) {
      var checkbox = headerCell.querySelector('input[type="checkbox"]');

      if (checkbox) {
        checkbox.checked = false;
      }
    }
  });
}

function getPaginationState(state) {
  var totalCount = state.filteredTotalCount > -1 ? state.filteredTotalCount : state.totalCount;
  return {
    id: state.id,
    info: getInfo(state.pageSize, state.pageIndex, totalCount),
    pageIndex: state.pageIndex,
    isTherePreviousPage: isTherePreviousPage(state),
    isThereNextPage: isThereNextPage(state),
    pageIndices: getPageIndices(state.firstVisiblePageIndex, getPageCount(totalCount, state.pageSize), state.visiblePageCount),
    currentPageIndex: state.pageIndex
  };
}

function getInfo(pageSize, pageIndex, totalCount) {
  var i = {
    firstOnPage: totalCount === 0 ? 0 : pageIndex * pageSize + 1,
    lastOnPage: Math.min(totalCount, (pageIndex + 1) * pageSize),
    total: totalCount
  };
  return "Showing entries ".concat(numberWithCommas(i.firstOnPage), "-").concat(numberWithCommas(i.lastOnPage), " of ").concat(numberWithCommas(i.total));
}

function isTherePreviousPage(state) {
  return state.pageIndex > 0;
}

function isThereNextPage(state) {
  var totalCount = state.filteredTotalCount > -1 ? state.filteredTotalCount : state.totalCount;
  return state.pageIndex + 1 < getPageCount(totalCount, state.pageSize);
}

function getPageCount(totalCount, pageSize) {
  return Math.floor(totalCount / pageSize) + Math.sign(totalCount % pageSize);
}

function getPageIndices(firstVisiblePageIndex, totalPageCount, visiblePageCount) {
  var result = [];
  var vpc = visiblePageCount;

  if (firstVisiblePageIndex > 0 && firstVisiblePageIndex < totalPageCount) {
    result.push(0);
  }

  var fvpi = firstVisiblePageIndex;

  if (firstVisiblePageIndex > 0 && totalPageCount - 1 - firstVisiblePageIndex < visiblePageCount) {
    fvpi = firstVisiblePageIndex - (visiblePageCount - (totalPageCount - 1 - firstVisiblePageIndex));

    if (fvpi === 0) {
      fvpi = 1;
    }
  }

  for (var i = fvpi; i < totalPageCount; i++) {
    if (result.length > vpc) {
      var last = result[result.length - 1];

      if (last < totalPageCount - 1) {
        result.push(totalPageCount - 1);
      }

      break;
    } else {
      result.push(i);
    }
  }

  return result;
}

function getPreviousClicked(tableContext) {
  return function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (isTherePreviousPage(tableContext.store.state)) {
      setPageIndex(tableContext, tableContext.store.state.pageIndex - 1);
    }
  };
}

function getNextClicked(tableContext) {
  return function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (isThereNextPage(tableContext.store.state)) {
      setPageIndex(tableContext, tableContext.store.state.pageIndex + 1);
    }
  };
}

function getPageClicked(tableContext) {
  return function (e) {
    e.preventDefault();
    e.stopPropagation();
    var cpi = Number(e.target.dataset.pageIndex);
    var pageIndex = Number(e.target.dataset.gotoPageIndex);

    if (pageIndex !== cpi) {
      setPageIndex(tableContext, pageIndex);
    }
  };
}

function setPageIndex(tableContext, pageIndex) {
  // Make sure that the new page index is within the visible page range
  var firstVisiblePageIndex = tableContext.store.state.firstVisiblePageIndex;

  if (pageIndex < firstVisiblePageIndex) {
    firstVisiblePageIndex = pageIndex;
  }

  if (pageIndex >= firstVisiblePageIndex + tableContext.store.state.visiblePageCount) {
    firstVisiblePageIndex = Math.max(pageIndex - tableContext.store.state.visiblePageCount + 1, 0);
  }

  hideChildTables(tableContext.store);
  deselectSelectAllCheckbox(tableContext);
  tableContext.store.setState({
    pageIndex: pageIndex,
    firstVisiblePageIndex: firstVisiblePageIndex
  });
  loadData(tableContext);
}

function setupEventHandlers(tableContext, element, state) {
  var pl = element.querySelector("#previous-link-".concat(state.id));
  var nl = element.querySelector("#next-link-".concat(state.id));
  var gl = element.querySelectorAll(".goto-link-".concat(state.id));

  if (state.isTherePreviousPage) {
    pl.addEventListener('click', getPreviousClicked(tableContext));
  }

  if (state.isThereNextPage) {
    nl.addEventListener('click', getNextClicked(tableContext));
  }

  gl.forEach(function (l) {
    return l.addEventListener('click', getPageClicked(tableContext));
  });
}

function createPagination(tableContext) {
  var store = tableContext.store;
  var ps = getPaginationState(store.state);
  var pg = Pagination(ps);
  setupEventHandlers(tableContext, pg, ps);
  return pg;
}
function updatePagination(tableContext) {
  var ps = getPaginationState(tableContext.store.state);
  var pg = tableContext.element.querySelector("#pagination-container-".concat(ps.id));

  if (pg) {
    var pl = PaginationList(ps);
    var pi = PaginationInfo(ps);
    setupEventHandlers(tableContext, pl, ps);
    var plc = pg.querySelector("#pagination-list-".concat(ps.id));
    elementEmpty(plc);
    plc.classList.remove('d-none');
    plc.appendChild(pl);
    var pic = pg.querySelector("#pagination-info-".concat(ps.id));
    elementEmpty(pic);
    pic.appendChild(pi);
  }
}

function getHeaderState(state) {
  return {
    id: state.id,
    small: state.small,
    searchColumns: state.searchColumns,
    sortHeader: state.sortHeader,
    sortDirection: state.sortDirection,
    searchEnabled: state.columnSearch || state.fullTextSearch,
    columnSearchInputAttributes: state.columnSearchInputAttributes,
    fullTextSearchInputAttributes: state.fullTextSearchInputAttributes
  };
}

function getOnSortClick(tableContext) {
  var store = tableContext.store;
  return function (h) {
    store.setState({
      sortHeader: h,
      sortDirection: !store.state.sortDirection ? 'asc' : store.state.sortDirection === 'asc' ? 'desc' : 'asc'
    }, false);
    sortData(tableContext);
  };
}

function isRowSortableOrSearchable(columnSearch, schemaProps) {
  var rs = columnSearch;

  for (var header in schemaProps) {
    if (schemaProps.hasOwnProperty(header) && (schemaProps[header].sortable || schemaProps[header].hasOwnProperty('columnSearch') && schemaProps[header].columnSearch)) {
      rs = true;
    }
  }

  return rs;
}

function createHeadRow(tableContext) {
  var store = tableContext.store;
  var state = getHeaderState(store.state);
  var containsColumnSortOrSearch = isRowSortableOrSearchable(store.state.columnSearch, store.state.schema.properties);
  createColumnSearchDebounce(tableContext);
  return HeadRow(store.state.columnSearch, containsColumnSortOrSearch, hasChildRow(tableContext.store.state), store.state.schema.properties, Object.keys(store.state.schema.properties), state, getOnSortClick(tableContext), getOnColumnSearchInput(tableContext), getOnColumnSearchKeydown(tableContext), getOnSelectAllCheckboxes(tableContext));
}

function appendChild(child, node) {
  if (Array.isArray(child)) {
    child.forEach(function (c) {
      return node.appendChild(c);
    });
  } else {
    node.appendChild(child);
  }
}

function getOnSearchInput(tableContext) {
  var store = tableContext.store;
  return function (e) {
    unhighlightRows(store);
    store.state.focusElement = e.target;
    store.state.fullTextQuery = e.target.value;

    if (store.state.debounceTime === -1 && (e.which || e.keyCode) && (e.which === 13 || e.keyCode === 13) || store.state.debounceTime > -1) {
      store.state.fullTextSearchDebounced();
    }
  };
}

function filter$1(store) {
  var query = store.state.fullTextQuery;

  if (query == null || query === '') {
    store.setState(store.getResetState());
  } else {
    var searchMatcher = parseQuery(store, query);

    var _fullTextSearchInCach = fullTextSearchInCache(searchMatcher, store.state.cache),
        filteredCache = _fullTextSearchInCach.filteredCache,
        filteredTotalCount = _fullTextSearchInCach.filteredTotalCount;

    store.setState(_objectSpread2({}, store.getResetState(), {
      fullTextQuery: store.state.fullTextQuery,
      focusElement: store.state.focusElement,
      filteredCache: filteredCache,
      filteredTotalCount: filteredTotalCount
    }));
  }
}

function createFullTextSearchDebounce(element, tableContext) {
  tableContext.store.state.fullTextSearchDebounced = debounce(function () {
    if (Object.keys(tableContext.store.state.cache).length === tableContext.store.state.totalCount) {
      filter$1(tableContext.store);
    } else {
      loadDataForSearch(tableContext);
    }
  }, tableContext.store.state.debounceTime === -1 ? 0 : tableContext.store.state.debounceTime);
}

function createFullTextSearch(tableContext) {
  var id = generateId();
  var element = FullTextSearch(id, tableContext.store.state.searchPlaceholder, getOnSearchInput(tableContext), tableContext.store.state.fullTextSearchInputAttributes);
  createFullTextSearchDebounce(element, tableContext);
  return element;
}

function hasIcons() {
  return document.getElementById('table_sort');
}

function renderTable(tableContext, element, store) {
  var tn = Table$1(store.state);
  elementEmpty(element);

  if (!hasIcons()) {
    var icons = Icons();
    appendChild(icons, element);
  }

  if (store.state.fullTextSearch) {
    appendChild(createFullTextSearch(tableContext), element);
  }

  appendChild(tn, element);
  store.setState({
    tableRendered: true
  }, false);
}

function renderFoot(element, store) {
  if (store.state.footers) {
    var tfoot = element.querySelector("#".concat(store.state.id, " > tfoot"));

    if (tfoot) {
      elementEmpty(tfoot);
      appendChild(FootRow(store.state.fixedHeight, store.state.schema.properties, Object.keys(store.state.schema.properties)), tfoot);
      store.setState({
        footRendered: true
      }, false);
    }
  }
}

function isSortable(state) {
  return Object.keys(state.schema.properties).filter(function (x) {
    return !!state.schema.properties[x].sortable;
  }).length > 0;
}

function renderHead(tableContext, element, store) {
  var thead = element.querySelector("#".concat(store.state.id, " > thead"));

  if (store.state.headers && thead) {
    if (isSortable(store.state)) {
      elementEmpty(thead);
      appendChild(createHeadRow(tableContext), thead);
    } else {
      if (!store.state.headRendered) {
        store.setState({
          headRendered: true
        }, false);
        elementEmpty(thead);
        appendChild(createHeadRow(tableContext), thead);
      }
    }
  }
}

function renderBody(tableContext, element, store) {
  var tbody = element.querySelector("#".concat(store.state.id, " > tbody"));

  if (hasRows(store)) {
    var pd = getRows(store);
    elementEmpty(tbody);
    pd.forEach(function (d) {
      return appendChild(d, tbody);
    });
  } else {
    elementEmpty(tbody);
    appendChild(EmptyTableRow(Object.keys(store.state.schema.properties).length, null, (store.state.filteredTotalCount > -1 ? store.state.filteredTotalCount : store.state.totalCount) === 0 ? elementFromString(store.state.emptyTemplate) : elementFromString(store.state.loadingTemplate)), tbody);
  }

  highlightRows(tableContext, element, store);
}

function renderPagination(tableContext, element, store) {
  if (store.state.totalCount > 10) {
    var pg = tableContext.element.querySelector("#pagination-container-".concat(store.state.id));

    if (!store.state.paginationRendered && !pg) {
      pg = createPagination(tableContext);
      appendChild(pg, element);
      store.setState({
        paginationRendered: true
      }, false);
    } else {
      updatePagination(tableContext);
    }

    if (store.state.displayedEntries) {
      renderDisplayEntries(tableContext, element, store);
    }
  } else {
    var pc = element.querySelector("#pagination-container-".concat(store.state.id));

    if (pc) {
      pc.parentElement.removeChild(pc);
    }
  }
}

function renderDisplayEntries(tableContext, element, store) {
  var de = DisplayedEntries(store);
  var select = de.querySelector('select');
  select.addEventListener('change', function (e) {
    deselectSelectAllCheckbox(tableContext);
    store.setState({
      pageSize: Number(e.target.value),
      pageIndex: 0,
      firstVisiblePageIndex: 0
    });
    loadData(tableContext);
  });
  var pc = element.querySelector("#pagination-container-".concat(store.state.id));

  if (pc) {
    var cont = pc.querySelector('.displayed-entries');

    if (cont) {
      cont.innerHTML = '';
      appendChild(de, cont);
    }
  }
}

function setFocus(element, store) {
  if (store.state.focusElement) {
    var fe = document.getElementById(store.state.focusElement);

    if (fe) {
      setTimeout(function () {
        fe.focus();

        if (fe.setSelectionRange) {
          var len = fe.value.length * 2;
          fe.setSelectionRange(len, len);
        } else {
          var v = fe.value;
          fe.value = v;
        }

        store.state.focusElement = null;
      });
    }
  }
}

function render(tableContext) {
  var element = tableContext.element;
  var store = tableContext.store;

  if (store.state.debug) {
    console.time('render');
  }

  if (!store.state.tableRendered) {
    renderTable(tableContext, element, store);
  }

  if (!store.state.footRendered) {
    renderFoot(element, store);
  }

  renderHead(tableContext, element, store);
  renderPagination(tableContext, element, store);
  renderBody(tableContext, element, store);
  setFocus(element, store);

  if (store.state.debug) {
    console.timeEnd('render');
  }
}

function createCellTemplates(tableContext) {
  var ct = {};
  Object.keys(tableContext.store.state.schema.properties).forEach(function (k) {
    var st = tableContext.store.state.schema.properties[k];

    if (st.template && typeof st.template === 'string') {
      ct[k] = st.template;
    }
  });

  if (Object.keys(ct).length > 0) {
    tableContext.store.state.cellTemplates = ct;
  }
}

var TableContext = /*#__PURE__*/function () {
  function TableContext(table, element, options) {
    _classCallCheck(this, TableContext);

    validateOptions(options);
    this.table = table;
    this.element = element;
    this.store = new Store(options);
    this.store.registerObserver(this);

    this._createCellTemplates();

    this._render();

    loadData(this);
  }

  _createClass(TableContext, [{
    key: "setData",
    value: function setData(totalCount, data) {
      var pageIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      this.store.setState(_objectSpread2({}, this.store.getResetState(), {
        totalCount: totalCount,
        pageIndex: pageIndex,
        cache: {}
      }), false);
      cacheData(this, 0, totalCount, data, false);
    }
  }, {
    key: "setRowData",
    value: function setRowData$1(index, data) {
      var render = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      setRowData(this, index, data, render);
    }
  }, {
    key: "removeRow",
    value: function removeRow(index) {
      removeData(this.store, index);
    }
  }, {
    key: "addRow",
    value: function addRow$1(data) {
      addRow(this, data);
    }
  }, {
    key: "disableRowActions",
    value: function disableRowActions(index) {
      enableRowActions(this.store, index, false);
    }
  }, {
    key: "enableRowActions",
    value: function enableRowActions$1(index) {
      enableRowActions(this.store, index, true);
    }
  }, {
    key: "toggleColumn",
    value: function toggleColumn$1(column) {
      toggleColumn(this.element, this.store, column);
    }
  }, {
    key: "toggleChildTable",
    value: function toggleChildTable$1(index) {
      toggleChildTable(this.store, index);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.store.setState(this.store.getResetState());
    }
  }, {
    key: "update",
    value: function update() {
      this._render();
    }
  }, {
    key: "_render",
    value: function _render() {
      render(this);
    }
  }, {
    key: "_createCellTemplates",
    value: function _createCellTemplates() {
      createCellTemplates(this);
    }
  }]);

  return TableContext;
}();

var Table$2 = /*#__PURE__*/function () {
  function Table(element, options) {
    _classCallCheck(this, Table);

    this.tableContext = new TableContext(this, element, options);
  }

  _createClass(Table, [{
    key: "setData",
    value: function setData(totalCount, data) {
      var pageIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      this.tableContext.setData(totalCount, data, pageIndex);
    }
  }, {
    key: "setRowData",
    value: function setRowData(index, data) {
      this.tableContext.setRowData(index, data);
    }
  }, {
    key: "removeRow",
    value: function removeRow(index) {
      this.tableContext.removeRow(index);
    }
  }, {
    key: "addRow",
    value: function addRow(data) {
      this.tableContext.addRow(data);
    }
  }, {
    key: "disableRowActions",
    value: function disableRowActions(index) {
      this.tableContext.disableRowActions(index);
    }
  }, {
    key: "enableRowActions",
    value: function enableRowActions(index) {
      this.tableContext.enableRowActions(index);
    }
  }, {
    key: "toggleColumn",
    value: function toggleColumn(column) {
      this.tableContext.toggleColumn(column);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.tableContext.reset();
    }
  }, {
    key: "toggleChildTable",
    value: function toggleChildTable(index) {
      this.tableContext.toggleChildTable(index);
    }
  }]);

  return Table;
}();

var Mosaic = {
  Table: Table$2
};

// This is hacky but it works with Rollup.


var build_cjs = Mosaic.Table || Mosaic;

module.exports = build_cjs;
